import {
  ADS_CAMPAIGN_OBJECTIVE_AWARENESS,
  ADS_CAMPAIGN_OBJECTIVE_AWARENESS_DESCRIPTION_EXPLANATION,
  ADS_CAMPAIGN_OBJECTIVE_AWARENESS_TITLE_EXPLANATION,
  ADS_CAMPAIGN_OBJECTIVE_TRAFFIC,
  ADS_CAMPAIGN_OBJECTIVE_TRAFFIC_TITLE_EXPLANATION,
  ADS_CAMPAIGN_OBJECTIVE_TRAFFIC_DESCRIPTION_EXPLANATION,
  ADS_CAMPAIGN_OBJECTIVE_ENGAGEMENT,
  ADS_CAMPAIGN_OBJECTIVE_ENGAGEMENT_TITLE_EXPLANATION,
  ADS_CAMPAIGN_OBJECTIVE_ENGAGEMENT_DESCRIPTION_EXPLANATION,
  ADS_CAMPAIGN_OBJECTIVE_LEADS,
  ADS_CAMPAIGN_OBJECTIVE_LEADS_LINKEDIN,
  ADS_CAMPAIGN_OBJECTIVE_LEADS_TITLE_EXPLANATION,
  ADS_CAMPAIGN_OBJECTIVE_LEADS_DESCRIPTION_EXPLANATION,
  ADS_CAMPAIGN_OBJECTIVE_SALES,
  ADS_CAMPAIGN_OBJECTIVE_SALES_TITLE_EXPLANATION,
  ADS_CAMPAIGN_OBJECTIVE_SALES_DESCRIPTION_EXPLANATION,
  ADS_CAMPAIGN_OBJECTIVE_VIDEO_VIEWS,
  ADS_CAMPAIGN_OBJECTIVE_VIDEO_VIEWS_TITLE_EXPLANATION,
  ADS_CAMPAIGN_OBJECTIVE_VIDEO_VIEWS_DESCRIPTION_EXPLANATION,
  ADS_CAMPAIGN_OBJECTIVE_WEBSITE_CONVERSIONS,
  ADS_CAMPAIGN_OBJECTIVE_WEBSITE_CONVERSIONS_TITLE_EXPLANATION,
  ADS_CAMPAIGN_OBJECTIVE_WEBSITE_CONVERSIONS_DESCRIPTION_EXPLANATION,
  ADS_CAMPAIGN_LINKEDIN_AD_FORMAT_IMAGE,
  ADS_CAMPAIGN_LINKEDIN_AD_FORMAT_VIDEO,
  ADS_CAMPAIGN_LINKEDIN_AD_FORMAT_CAROUSEL,
  ADS_CAMPAIGN_CALL_TO_ACTION_SEE_MENU,
  ADS_CAMPAIGN_CALL_TO_ACTION_SHOP_NOW,
  ADS_CAMPAIGN_CALL_TO_ACTION_SIGN_UP,
  ADS_CAMPAIGN_CALL_TO_ACTION_SUBSCRIBE,
  ADS_CAMPAIGN_CALL_TO_ACTION_WATCH_MORE,
  ADS_CAMPAIGN_CALL_TO_ACTION_APPLY_NOW,
  ADS_CAMPAIGN_CALL_TO_ACTION_APPLY,
  ADS_CAMPAIGN_CALL_TO_ACTION_VIEW_QUOTE,
  ADS_CAMPAIGN_CALL_TO_ACTION_JOIN,
  ADS_CAMPAIGN_CALL_TO_ACTION_ATTEND,
  ADS_CAMPAIGN_CALL_TO_ACTION_REQUEST_DEMO,
  ADS_CAMPAIGN_CALL_TO_ACTION_SEE_MORE,
  ADS_CAMPAIGN_CALL_TO_ACTION_REGISTER,
  ADS_CAMPAIGN_CALL_TO_ACTION_BOOK_NOW,
  ADS_CAMPAIGN_CALL_TO_ACTION_CONTACT_US,
  ADS_CAMPAIGN_CALL_TO_ACTION_DOWNLOAD,
  ADS_CAMPAIGN_CALL_TO_ACTION_GET_QUOTE,
  ADS_CAMPAIGN_CALL_TO_ACTION_GET_SHOWTIMES,
  ADS_CAMPAIGN_CALL_TO_ACTION_LEARN_MORE,
  ADS_CAMPAIGN_CALL_TO_ACTION_LISTEN_NOW,
  ADS_CAMPAIGN_CALL_TO_ACTION_ORDER_NOW,
  ADS_CAMPAIGN_CALL_TO_ACTION_GET_OFFER,
  ADS_CAMPAIGN_CALL_TO_ACTION_PLAY_GAME,
  ADS_CAMPAIGN_CALL_TO_ACTION_EXPLORE_MORE,
  ADS_CAMPAIGN_CALL_TO_ACTION_INSTALL_NOW,
  ADS_CAMPAIGN_CALL_TO_ACTION_USE_APP,
  ADS_CAMPAIGN_TYPE_BUDGET_DAILY,
  ADS_CAMPAIGN_TYPE_BUDGET_DAILY_TITLE_EXPLANATION,
  ADS_CAMPAIGN_TYPE_BUDGET_DAILY_DESCRIPTION_EXPLANATION,
  ADS_CAMPAIGN_TYPE_BUDGET_LIFETIME,
  ADS_CAMPAIGN_TYPE_BUDGET_TOTAL_TITLE_EXPLANATION,
  ADS_CAMPAIGN_TYPE_BUDGET_TOTAL_DESCRIPTION_EXPLANATION,
  SPANISH,
  ENGLISH,
  ADS_CAMPAIGN_CUSTOM_AUDIENCE_TYPE_WEBSITE,
  ADS_CAMPAIGN_CUSTOM_AUDIENCE_TYPE_CUSTOMER_LIST,
  ADS_CAMPAIGNS_CUSTOM_AUDIENCE_TYPE_WEBSITE_TITLE_EXPLANATION,
  ADS_CAMPAIGNS_CUSTOM_AUDIENCE_TYPE_WEBSITE_DESCRIPTION_EXPLANATION,
  ADS_CAMPAIGNS_CUSTOM_AUDIENCE_TYPE_CUSTOMER_LIST_TITLE_EXPLANATION,
  ADS_CAMPAIGNS_CUSTOM_AUDIENCE_TYPE_CUSTOMER_LIST_DESCRIPTION_EXPLANATION,
  ADS_CAMPAIGN_CALL_TO_ACTION_WATCH_NOW,
  ADS_CAMPAIGN_CALL_TO_ACTION_READ_MORE,
  ADS_CAMPAIGN_CALL_TO_ACTION_VIEW_NOW,
  ADS_CAMPAIGN_CALL_TO_ACTION_INTERESTED,
  ADS_CAMPAIGN_CALL_TO_ACTION_GET_TICKETS_NOW,
  ADS_CAMPAIGN_CALL_TO_ACTION_EXPERIENCE_NOW,
  ADS_CAMPAIGN_CALL_TO_ACTION_PRE_ORDER_NOW,
  ADS_CAMPAIGN_CALL_TO_ACTION_VISIT_STORE,
  ADS_CAMPAIGN_CUSTOM_EVENT_COMPLETE_REGISTRATION,
  ADS_CAMPAIGN_CUSTOM_EVENT_CONTACT,
  ADS_CAMPAIGN_CUSTOM_EVENT_FIND_LOCATION,
  ADS_CAMPAIGN_CUSTOM_EVENT_LEAD,
  ADS_CAMPAIGN_CUSTOM_EVENT_SCHEDULE,
  ADS_CAMPAIGN_CUSTOM_EVENT_SEARCH,
  ADS_CAMPAIGN_CUSTOM_EVENT_START_TRIAL,
  ADS_CAMPAIGN_CUSTOM_EVENT_SUBMIT_APPLICATION,
  ADS_CAMPAIGN_CUSTOM_EVENT_SUBSCRIBE,
  ADS_CAMPAIGN_CUSTOM_EVENT_CONTENT_VIEW,
  ADS_CAMPAIGN_CUSTOM_EVENT_ADD_TO_CART,
  ADS_CAMPAIGN_CUSTOM_EVENT_ADD_TO_WISHLIST,
  ADS_CAMPAIGN_CUSTOM_EVENT_DONATE,
  ADS_CAMPAIGN_CUSTOM_EVENT_INITIATED_CHECKOUT,
  ADS_CAMPAIGN_CUSTOM_EVENT_PURCHASE,
  ADS_CAMPAIGN_CUSTOM_EVENT_ADD_PAYMENT_INFO,
  ADS_CAMPAIGN_CUSTOM_EVENT_CUSTOMIZE_PRODUCT,
  ADS_CAMPAIGN_CUSTOM_EVENT_CLICK_BUTTON,
  ADS_CAMPAIGN_CUSTOM_EVENT_SUBMIT_FORM,
  ADS_CAMPAIGN_CUSTOM_EVENT_PLACE_ORDER,
  PORTUGUESE,
  FRENCH,
  ITALIAN,
  RUSSIAN,
  JAPANESE,
  MANDARIN,
  HINDI,
  HEBREW,
  HUNGARIAN,
  ARABIC,
  GERMAN,
  DUTCH,
  KOREAN,
  INDONESIAN,
  TURKISH,
  CROATIAN,
  CZECH,
  SLOVAK,
  POLISH,
  BULGARIAN,
  DANISH,
  GREEK,
  TIKTOK_PRIVACY_LEVEL_PUBLIC_TO_EVERYONE,
  TIKTOK_PRIVACY_LEVEL_MUTUAL_FOLLOW_FRIENDS,
  TIKTOK_PRIVACY_LEVEL_FOLLOWER_OF_CREATOR,
  TIKTOK_PRIVACY_LEVEL_SELF_ONLY,
  ADS_CAMPAIGN_TYPE_SEARCH_TITLE_EXPLANATION,
  ADS_CAMPAIGN_TYPE_SEARCH_DESCRIPTION_EXPLANATION,
  // ADS_CAMPAIGN_TYPE_SHOPPING_TITLE_EXPLANATION,
  // ADS_CAMPAIGN_TYPE_SHOPPING_DESCRIPTION_EXPLANATION,
  // ADS_CAMPAIGN_TYPE_VIDEO_DESCRIPTION_EXPLANATION,
  // ADS_CAMPAIGN_TYPE_VIDEO_TITLE_EXPLANATION,
  ADS_CAMPAIGN_TYPE_SEARCH,
  GOOGLE_SEARCH_AD_GROUP_TYPE_STANDARD,
  GOOGLE_SEARCH_AD_GROUP_TYPE_DSA,
  GOOGLE_WEBPAGE_CRITERION_URL_EQUALS,
  GOOGLE_WEBPAGE_CRITERION_URL_CONTAINS,
  // ADS_CAMPAIGN_TYPE_SHOPPING,
  // ADS_CAMPAIGN_TYPE_VIDEO,
  ADS_META_DESTINATION_TYPE_WEBSITE,
  OPTIMIZATION_GOAL_OPTION_REACH,
  OPTIMIZATION_GOAL_OPTION_THRUPLAY,
  OPTIMIZATION_GOAL_OPTION_LINK_CLICKS,
  OPTIMIZATION_GOAL_OPTION_LANDING_PAGE_VIEWS,
  ADS_META_DESTINATION_TYPE_INSTAGRAM_PROFILE,
  ADVERTISER,
  MARKETER,
  VIEWER,
  ADS_META_DESTINATION_TYPE_ON_VIDEO,
  ADS_META_DESTINATION_TYPE_ON_POST,
  ADS_META_DESTINATION_TYPE_MESSAGES_ON_INSTAGRAM,
  ADS_META_DESTINATION_TYPE_MESSAGES_ON_MESSENGER,
  ADS_META_DESTINATION_TYPE_MESSAGES_ON_INSTAGRAM_AND_MESSENGER,
  ADS_META_DESTINATION_TYPE_INSTANT_FORM,
  ADS_META_DESTINATION_TYPE_WHATSAPP,
  ADS_CAMPAIGN_REPORT_BREAKDOWN_WEEKLY,
  ADS_CAMPAIGN_REPORT_BREAKDOWN_MONTHLY,
  UKRAINIAN,
  KEYWORD_BROAD_MATCH_TYPE_OPTION,
  KEYWORD_PHRASE_MATCH_TYPE_OPTION,
  KEYWORD_EXACT_MATCH_TYPE_OPTION,
  ADS_CAMPAIGN_TYPE_PERFORMANCE_MAX,
  ADS_CAMPAIGN_TYPE_PERFORMANCE_MAX_TITLE_EXPLANATION,
  ADS_CAMPAIGN_TYPE_PERFORMANCE_MAX_DESCRIPTION_EXPLANATION,
  ADS_CAMPAIGN_TYPE_APP,
  ADS_CAMPAIGN_TYPE_APP_TITLE_EXPLANATION,
  ADS_CAMPAIGN_TYPE_APP_DESCRIPTION_EXPLANATION,
  ACTIVE,
  DEACTIVATED,
  ADS_META_DESTINATION_TYPE_CATALOG,
  ADS_CAMPAIGN_OBJECTIVE_APP_PROMOTION,
  ADS_CAMPAIGN_OBJECTIVE_APP_PROMOTION_TITLE_EXPLANATION,
  ADS_CAMPAIGN_OBJECTIVE_APP_PROMOTION_DESCRIPTION_EXPLANATION,
  ADS_META_DESTINATION_TYPE_GOOGLE_PLAY,
  ADS_META_DESTINATION_TYPE_APP_STORE,
  FINISHED,
  ADS_CAMPAIGN_APP_PROMOTION_TYPE_APP_INSTALL,
  ADS_CAMPAIGN_APP_PROMOTION_TYPE_APP_RETARGETING,
  CATEGORY_ANIMALS_PET_SUPPLIES,
  CATEGORY_ARTS_ENTERTAINMENT,
  CATEGORY_BUSINESS_INDUSTRIAL,
  CATEGORY_CAMERAS_OPTICS,
  CATEGORY_CLOTHING_ACCESSORIES,
  CATEGORY_ELECTRONICS,
  CATEGORY_FOOD_BEVERAGES,
  CATEGORY_FURNITURE,
  CATEGORY_HEALTH_BEAUTY,
  CATEGORY_HOME_GARDEN,
  CATEGORY_BABY_TODDLER,
  CATEGORY_HARDWARE,
  CATEGORY_MATURE,
  CATEGORY_MEDIA,
  CATEGORY_VEHICLES_PARTS,
  CATEGORY_OFFICE_SUPPLIES,
  CATEGORY_SPORTING_GOODS,
  CATEGORY_TOYS_GAMES,
  CATEGORY_SOFTWARE,
  CATEGORY_LUGGAGE_BAGS,
  CATEGORY_RELIGIOUS_CEREMONIAL,
  ADS_META_DESTINATION_TYPE_APP,
  ADS_CAMPAIGN_META_FALLBACK_DEEPLINK_WITH_WEB_FALLBACK,
  ADS_CAMPAIGN_META_FALLBACK_DEEPLINK_WITH_APPSTORE_FALLBACK,
  ADS_CAMPAIGN_META_FALLBACK_WEB_ONLY,
  ADS_CAMPAIGN_META_FALLBACK_CATALOG,
  ADS_CAMPAIGN_META_FALLBACK_WEB_ONLY_LABEL,
  ADS_CAMPAIGN_META_FALLBACK_DEEPLINK_WITH_WEB_FALLBACK_LABEL,
  ADS_CAMPAIGN_META_FALLBACK_DEEPLINK_WITH_APPSTORE_FALLBACK_LABEL,
  ADS_CAMPAIGN_META_SPECIAL_AD_CATEGORIES_OPTION_HOUSING,
  ADS_CAMPAIGN_META_SPECIAL_AD_CATEGORIES_OPTION_EMPLOYMENT,
  ADS_CAMPAIGN_META_SPECIAL_AD_CATEGORIES_OPTION_FINANCIAL_PRODUCTS_SERVICES,
  ADS_CAMPAIGN_META_SPECIAL_AD_CATEGORIES_OPTION_ISSUES_ELECTIONS_POLITICS,
  ADS_CAMPAIGN_TIKTOK_SPECIAL_AD_CATEGORIES_OPTION_HOUSING,
  ADS_CAMPAIGN_TIKTOK_SPECIAL_AD_CATEGORIES_OPTION_EMPLOYMENT,
  ADS_CAMPAIGN_TIKTOK_SPECIAL_AD_CATEGORIES_OPTION_CREDIT,
  // ADS_CAMPAIGN_CALL_TO_ACTION_SEND_MESSAGE,
  ADS_TIKTOK_APP_EVENT_ACTIVE_OPTION,
  ADS_TIKTOK_APP_EVENT_DOWNLOAD_START_OPTION,
  ADS_TIKTOK_APP_EVENT_ACTIVE_REGISTER_OPTION,
  ADS_TIKTOK_APP_EVENT_ACTIVE_PAY_OPTION,
  ADS_TIKTOK_APP_EVENT_IN_APP_ORDER_OPTION,
  ADS_TIKTOK_APP_EVENT_IN_APP_CART_OPTION,
  ADS_TIKTOK_APP_EVENT_IN_APP_DETAIL_UV_OPTION,
  ADS_TIKTOK_APP_EVENT_NEXT_DAY_OPEN_OPTION,
  ADS_TIKTOK_APP_EVENT_LOGIN_OPTION,
  ADS_TIKTOK_APP_EVENT_LAUNCH_APP_OPTION,
  ADS_TIKTOK_APP_EVENT_COMPLETE_TUTORIAL_OPTION,
  ADS_TIKTOK_APP_EVENT_SEARCH_OPTION,
  ADS_TIKTOK_APP_EVENT_START_TRIAL_OPTION,
  ADS_TIKTOK_APP_EVENT_SUBSCRIBE_OPTION,
  ADS_CAMPAIGN_REPORT_BREAKDOWN_DAILY,
  ADS_CAMPAIGN_CALL_TO_ACTION_GET_DIRECTIONS,
  ADS_CAMPAIGN_APP_PROMOTION_BOTH,
  ADS_CAMPAIGN_APP_PROMOTION_IOS,
  ADS_CAMPAIGN_APP_PROMOTION_ANDROID,
  ADS_CAMPAIGN_BUYING_TYPE_RESERVED,
  ADS_CAMPAIGN_BUYING_TYPE_AUCTION,
  ADS_META_DESTINATION_TYPE_WEBSITE_AND_IN_STORE,
  ADS_META_DESTINATION_TYPE_WEBSITE_APP_AND_IN_STORE,
  ADS_META_DESTINATION_TYPE_WEBSITE_AND_APP,
  ACCENT_ES_ARGENTINO,
  ACCENT_ES_COLOMBIANO,
  // ACCENT_ES_CHILENO,
  // ACCENT_ES_MEXICANO,
  ACCENT_ES_ESPANOL_ESPANA,
  // ACCENT_ES_PERUANO,
  // ACCENT_ES_VENEZOLANO,
  // ACCENT_ES_CARIBENO,
  ACCENT_ES_NEUTRAL,
  ACCENT_EN_AMERICAN,
  ACCENT_EN_BRITISH,
  ACCENT_EN_AUSTRALIAN,
  VIDEO_TYPE_OTHER,
  CREATE_ADS_CAMPAIGN_TEMPLATE_SINGULAR,
  CREATE_ADS_CAMPAIGN_TEMPLATE_MULTIPLE,
  CREATE_ADS_CAMPAIGN_TIKTOK_CAMPAIGN_TYPE_OPTION_WEBSITE,
  CREATE_ADS_CAMPAIGN_TIKTOK_CAMPAIGN_TYPE_OPTION_APP,
  CHINESE,
  VIDEO_TYPE_SURREAL,
  VIDEO_TYPE_MEGA_CREATIVE,
  ADMIN_KPI_PRIMARY_LEADS,
  ADMIN_KPI_PRIMARY_SALES,
  ADMIN_KPI_PRIMARY_MESSAGES,
  ADMIN_KPI_PRIMARY_INTERACTIONS,
  ADMIN_KPI_PRIMARY_TRAFFIC,
  ADMIN_KPI_PRIMARY_CONVERSIONS,
  ADMIN_KPI_PRIMARY_DOWNLOADS,
  ADMIN_KPI_PRIMARY_REACH,
  ADMIN_KPI_PRIMARY_STORE_VISITS,
  DESIGNER,
  ACCENT_ES_CHILENO,
  ACCENT_ES_MEXICANO,
} from "../i18n/keysTranslations";
import {
  MODAL_CUSTOM_REPORT_TEMPLATE_GENERAL,
  MODAL_CUSTOM_REPORT_TEMPLATE_SALES,
  MODAL_CUSTOM_REPORT_TEMPLATE_LEADS,
  MODAL_CUSTOM_REPORT_TEMPLATE_CUSTOM,
  MODAL_CUSTOM_REPORT_FORMAT_PDF,
  MODAL_CUSTOM_REPORT_FORMAT_PPTX,
} from "../i18n/keysTranslations";
import {
  VIDEO_TYPE_UNBOXING,
  VIDEO_TYPE_PRODUCT_SHOWCASE,
  VIDEO_TYPE_UGC,
  VIDEO_TYPE_LIFESTYLE,
  VIDEO_TYPE_TESTIMONIALS_REVIEWS,
  VIDEO_TYPE_TESTIMONIAL,
  VIDEO_TYPE_EMOTIONAL_STORYTELLING,
  VIDEO_TYPE_CASE_STUDY,
  VIDEO_TYPE_CORPORATE,
} from "../i18n/keysTranslations";
import {
  ADS_CAMPAIGN_CUSTOM_AUDIENCE_TYPE_CUSTOMER_LIST_OPTION,
  ADS_CAMPAIGN_CUSTOM_AUDIENCE_TYPE_WEBSITE_OPTION,
  ADS_CAMPAIGN_META_DESTINATION_TYPE_INSTAGRAM_PROFILE_OPTION,
  ADS_CAMPAIGN_META_DESTINATION_TYPE_LEAD_INSTANT_FORM_OPTION,
  // ADS_CAMPAIGN_META_DESTINATION_TYPE_LEAD_FROM_IG_DIRECT_OPTION,
  ADS_CAMPAIGN_META_DESTINATION_TYPE_MESSAGES_ON_INSTAGRAM_AND_MESSENGER_OPTION,
  ADS_CAMPAIGN_META_DESTINATION_TYPE_MESSAGES_ON_INSTAGRAM_OPTION,
  ADS_CAMPAIGN_META_DESTINATION_TYPE_MESSAGES_ON_MESSAGE_OPTION,
  ADS_CAMPAIGN_META_DESTINATION_TYPE_ON_POST_OPTION,
  ADS_CAMPAIGN_META_DESTINATION_TYPE_ON_VIDEO_OPTION,
  ADS_CAMPAIGN_META_DESTINATION_TYPE_WEBSITE_OPTION,
  ADS_CAMPAIGN_META_OPTIMIZATION_GOAL_REACH,
  ADS_CAMPAIGN_META_OPTIMIZATION_GOAL_THRUPLAY,
  ADS_CAMPAIGN_META_OPTIMIZATION_GOAL_LINK_CLICKS,
  ADS_CAMPAIGN_META_OPTIMIZATION_GOAL_LANDING_PAGE_VIEWS,
  ADS_CAMPAIGN_META_DESTINATION_TYPE_WHATSAPP_OPTION,
  ADS_CAMPAIGN_OBJECTIVE_AWARENESS_OPTION,
  ADS_CAMPAIGN_OBJECTIVE_ENGAGEMENT_OPTION,
  ADS_CAMPAIGN_OBJECTIVE_LEADS_OPTION,
  ADS_CAMPAIGN_OBJECTIVE_SALES_OPTION,
  ADS_CAMPAIGN_OBJECTIVE_TRAFFIC_OPTION,
  ADS_CAMPAIGN_OBJECTIVE_VIDEO_VIEWS_OPTION,
  ADS_CAMPAIGN_OBJECTIVE_WEBSITE_CONVERSIONS_OPTION,
  ADS_CAMPAIGN_TYPE_BUDGET_DAILY_OPTION,
  ADS_CAMPAIGN_TYPE_BUDGET_LIFETIME_OPTION,
  ADVERTISER_ROLE,
  MARKETER_ROLE,
  VIEWER_ROLE,
  ADS_CAMPAIGN_TYPE_SEARCH_OPTION,
  ADS_CAMPAIGN_TYPE_PERFORMANCE_MAX_OPTION,
  ADS_CAMPAIGN_TYPE_APP_OPTION,
  ADS_GOOGLE_SEARCH_AD_GROUP_TYPE_STANDARD_OPTION,
  ADS_GOOGLE_SEARCH_AD_GROUP_TYPE_DSA_OPTION,
  ADS_GOOGLE_WEBPAGE_CRITERION_URL_EQUALS_OPTION,
  ADS_GOOGLE_WEBPAGE_CRITERION_URL_CONTAINS_OPTION,
  ADS_CAMPAIGN_STATUS_ACTIVE,
  ADS_CAMPAIGN_STATUS_DEACTIVATED,
  ADS_CAMPAIGN_META_DESTINATION_TYPE_CATALOG_OPTION,
  ADS_CAMPAIGN_OBJECTIVE_APP_PROMOTION_OPTION,
  ADS_CAMPAIGN_META_DESTINATION_TYPE_GOOGLE_PLAY_OPTION,
  ADS_CAMPAIGN_META_DESTINATION_TYPE_APP_STORE_OPTION,
  ADS_CAMPAIGN_STATUS_FINISHED,
  ADS_CAMPAIGN_APP_PROMOTION_TYPE_APP_INSTALL_OPTION,
  ADS_CAMPAIGN_APP_PROMOTION_TYPE_RETARGETING_OPTION,
  ADS_CAMPAIGN_META_DESTINATION_TYPE_APP_OPTION,
  ADS_CAMPAIGN_META_FALLBACK_DEEPLINK_WITH_WEB_FALLBACK_OPTION,
  ADS_CAMPAIGN_META_FALLBACK_DEEPLINK_WITH_APPSTORE_FALLBACK_OPTION,
  ADS_CAMPAIGN_META_FALLBACK_WEB_ONLY_OPTION,
  ADS_CAMPAIGN_META_FALLBACK_CATALOG_OPTION,
  // ADS_CALL_TO_ACTION_SEND_MESSAGE_PAGE_META_VALUE,
  ADS_CAMPAIGN_APP_PROMOTION_ANDROID_OPTION,
  ADS_CAMPAIGN_APP_PROMOTION_IOS_OPTION,
  ADS_CAMPAIGN_APP_PROMOTION_BOTH_OPTION,
  ADS_CAMPAIGN_BUYING_TYPE_RESERVED_OPTION,
  ADS_CAMPAIGN_BUYING_TYPE_AUCTION_OPTION,
  ADS_CAMPAIGN_META_DESTINATION_TYPE_WEBSITE_AND_IN_STORE_OPTION,
  ADS_CAMPAIGN_META_DESTINATION_TYPE_WEBSITE_APP_AND_IN_STORE_OPTION,
  ADS_CAMPAIGN_META_DESTINATION_TYPE_WEBSITE_AND_APP_OPTION,
  ADS_CAMPAIGN_TEMPLATE_SINGULAR_OPTION,
  ADS_CAMPAIGN_TEMPLATE_MULTIPLE_OPTION,
  ADS_CAMPAIGN_META_SPECIAL_AD_CATEGORIES_HOUSING,
  ADS_CAMPAIGN_META_SPECIAL_AD_CATEGORIES_EMPLOYMENT,
  ADS_CAMPAIGN_META_SPECIAL_AD_CATEGORIES_FINANCIAL_PRODUCTS_SERVICES,
  ADS_CAMPAIGN_META_SPECIAL_AD_CATEGORIES_ISSUES_ELECTIONS_POLITICS,
  ADS_CAMPAIGN_TIKTOK_SPECIAL_AD_CATEGORIES_HOUSING,
  ADS_CAMPAIGN_TIKTOK_SPECIAL_AD_CATEGORIES_EMPLOYMENT,
  ADS_CAMPAIGN_TIKTOK_SPECIAL_AD_CATEGORIES_CREDIT,
  ADS_CAMPAIGN_TIKTOK_CAMPAIGN_TYPE_WEBSITE_OPTION,
  ADS_CAMPAIGN_TIKTOK_CAMPAIGN_TYPE_APP_OPTION,
  // ADS_CAMPAIGN_TYPE_SHOPPING_OPTION,
  // ADS_CAMPAIGN_TYPE_VIDEO_OPTION,
  linkedinCurrenciesWithDecimals,
  metaCurrenciesWithDecimals,
  googleCurrenciesWithDecimals,
  DESIGNER_ROLE,
} from "./constants";

const mergeAdminKpiCpaCurrencyCodes = () => {
  const merged = [
    ...metaCurrenciesWithDecimals,
    ...googleCurrenciesWithDecimals,
    ...linkedinCurrenciesWithDecimals,
  ];
  return [...new Set(merged)].sort((a, b) => a.localeCompare(b));
};

export const ADMIN_KPI_CPA_CURRENCY_CODES = mergeAdminKpiCpaCurrencyCodes();

export const optionsAdsCampaignSpecialAdCategoriesMeta = [
  {
    value: ADS_CAMPAIGN_META_SPECIAL_AD_CATEGORIES_HOUSING,
    label: ADS_CAMPAIGN_META_SPECIAL_AD_CATEGORIES_OPTION_HOUSING,
  },
  {
    value: ADS_CAMPAIGN_META_SPECIAL_AD_CATEGORIES_EMPLOYMENT,
    label: ADS_CAMPAIGN_META_SPECIAL_AD_CATEGORIES_OPTION_EMPLOYMENT,
  },
  {
    value: ADS_CAMPAIGN_META_SPECIAL_AD_CATEGORIES_FINANCIAL_PRODUCTS_SERVICES,
    label:
      ADS_CAMPAIGN_META_SPECIAL_AD_CATEGORIES_OPTION_FINANCIAL_PRODUCTS_SERVICES,
  },
  {
    value: ADS_CAMPAIGN_META_SPECIAL_AD_CATEGORIES_ISSUES_ELECTIONS_POLITICS,
    label:
      ADS_CAMPAIGN_META_SPECIAL_AD_CATEGORIES_OPTION_ISSUES_ELECTIONS_POLITICS,
  },
];

export const optionsAdsCampaignSpecialAdCategoriesTikTok = [
  {
    value: ADS_CAMPAIGN_TIKTOK_SPECIAL_AD_CATEGORIES_HOUSING,
    label: ADS_CAMPAIGN_TIKTOK_SPECIAL_AD_CATEGORIES_OPTION_HOUSING,
  },
  {
    value: ADS_CAMPAIGN_TIKTOK_SPECIAL_AD_CATEGORIES_EMPLOYMENT,
    label: ADS_CAMPAIGN_TIKTOK_SPECIAL_AD_CATEGORIES_OPTION_EMPLOYMENT,
  },
  {
    value: ADS_CAMPAIGN_TIKTOK_SPECIAL_AD_CATEGORIES_CREDIT,
    label: ADS_CAMPAIGN_TIKTOK_SPECIAL_AD_CATEGORIES_OPTION_CREDIT,
  },
];

export const optionsAdsCampaignStatus = [
  {
    label: ACTIVE,
    value: ADS_CAMPAIGN_STATUS_ACTIVE,
  },
  {
    label: DEACTIVATED,
    value: ADS_CAMPAIGN_STATUS_DEACTIVATED,
  },
  {
    label: FINISHED,
    value: ADS_CAMPAIGN_STATUS_FINISHED,
  },
];

export const optionsAdsCampaignObjectivesMeta = [
  {
    value: ADS_CAMPAIGN_OBJECTIVE_AWARENESS_OPTION,
    label: ADS_CAMPAIGN_OBJECTIVE_AWARENESS,
    title: ADS_CAMPAIGN_OBJECTIVE_AWARENESS_TITLE_EXPLANATION,
    explanation: ADS_CAMPAIGN_OBJECTIVE_AWARENESS_DESCRIPTION_EXPLANATION,
  },
  {
    value: ADS_CAMPAIGN_OBJECTIVE_TRAFFIC_OPTION,
    label: ADS_CAMPAIGN_OBJECTIVE_TRAFFIC,
    title: ADS_CAMPAIGN_OBJECTIVE_TRAFFIC_TITLE_EXPLANATION,
    explanation: ADS_CAMPAIGN_OBJECTIVE_TRAFFIC_DESCRIPTION_EXPLANATION,
  },
  {
    value: ADS_CAMPAIGN_OBJECTIVE_ENGAGEMENT_OPTION,
    label: ADS_CAMPAIGN_OBJECTIVE_ENGAGEMENT,
    title: ADS_CAMPAIGN_OBJECTIVE_ENGAGEMENT_TITLE_EXPLANATION,
    explanation: ADS_CAMPAIGN_OBJECTIVE_ENGAGEMENT_DESCRIPTION_EXPLANATION,
  },
  {
    value: ADS_CAMPAIGN_OBJECTIVE_APP_PROMOTION_OPTION,
    label: ADS_CAMPAIGN_OBJECTIVE_APP_PROMOTION,
    title: ADS_CAMPAIGN_OBJECTIVE_APP_PROMOTION_TITLE_EXPLANATION,
    explanation: ADS_CAMPAIGN_OBJECTIVE_APP_PROMOTION_DESCRIPTION_EXPLANATION,
  },
  {
    value: ADS_CAMPAIGN_OBJECTIVE_LEADS_OPTION,
    label: ADS_CAMPAIGN_OBJECTIVE_LEADS,
    title: ADS_CAMPAIGN_OBJECTIVE_LEADS_TITLE_EXPLANATION,
    explanation: ADS_CAMPAIGN_OBJECTIVE_LEADS_DESCRIPTION_EXPLANATION,
  },
  {
    value: ADS_CAMPAIGN_OBJECTIVE_SALES_OPTION,
    label: ADS_CAMPAIGN_OBJECTIVE_SALES,
    title: ADS_CAMPAIGN_OBJECTIVE_SALES_TITLE_EXPLANATION,
    explanation: ADS_CAMPAIGN_OBJECTIVE_SALES_DESCRIPTION_EXPLANATION,
  },
];
export const optionsAdsCampaignObjectivesTikTok = [
  {
    value: ADS_CAMPAIGN_OBJECTIVE_AWARENESS_OPTION,
    label: ADS_CAMPAIGN_OBJECTIVE_AWARENESS,
    title: ADS_CAMPAIGN_OBJECTIVE_AWARENESS_TITLE_EXPLANATION,
    explanation: ADS_CAMPAIGN_OBJECTIVE_AWARENESS_DESCRIPTION_EXPLANATION,
  },
  {
    value: ADS_CAMPAIGN_OBJECTIVE_TRAFFIC_OPTION,
    label: ADS_CAMPAIGN_OBJECTIVE_TRAFFIC,
    title: ADS_CAMPAIGN_OBJECTIVE_TRAFFIC_TITLE_EXPLANATION,
    explanation: ADS_CAMPAIGN_OBJECTIVE_TRAFFIC_DESCRIPTION_EXPLANATION,
  },
  {
    value: ADS_CAMPAIGN_OBJECTIVE_ENGAGEMENT_OPTION,
    label: ADS_CAMPAIGN_OBJECTIVE_ENGAGEMENT,
    title: ADS_CAMPAIGN_OBJECTIVE_ENGAGEMENT_TITLE_EXPLANATION,
    explanation: ADS_CAMPAIGN_OBJECTIVE_ENGAGEMENT_DESCRIPTION_EXPLANATION,
  },
  {
    value: ADS_CAMPAIGN_OBJECTIVE_APP_PROMOTION_OPTION,
    label: ADS_CAMPAIGN_OBJECTIVE_APP_PROMOTION,
    title: ADS_CAMPAIGN_OBJECTIVE_APP_PROMOTION_TITLE_EXPLANATION,
    explanation: ADS_CAMPAIGN_OBJECTIVE_APP_PROMOTION_DESCRIPTION_EXPLANATION,
  },
  {
    value: ADS_CAMPAIGN_OBJECTIVE_LEADS_OPTION,
    label: ADS_CAMPAIGN_OBJECTIVE_LEADS,
    title: ADS_CAMPAIGN_OBJECTIVE_LEADS_TITLE_EXPLANATION,
    explanation: ADS_CAMPAIGN_OBJECTIVE_LEADS_DESCRIPTION_EXPLANATION,
  },
  {
    value: ADS_CAMPAIGN_OBJECTIVE_SALES_OPTION,
    label: ADS_CAMPAIGN_OBJECTIVE_SALES,
    title: ADS_CAMPAIGN_OBJECTIVE_SALES_TITLE_EXPLANATION,
    explanation: ADS_CAMPAIGN_OBJECTIVE_SALES_DESCRIPTION_EXPLANATION,
  },
];

export const optionsAdsCampaignAppPromotionTypesTikTok = [
  {
    value: ADS_CAMPAIGN_APP_PROMOTION_TYPE_APP_INSTALL_OPTION,
    label: ADS_CAMPAIGN_APP_PROMOTION_TYPE_APP_INSTALL,
  },
  {
    value: ADS_CAMPAIGN_APP_PROMOTION_TYPE_RETARGETING_OPTION,
    label: ADS_CAMPAIGN_APP_PROMOTION_TYPE_APP_RETARGETING,
  },
];

export const optionsAdsSalesCampaignTypeTikTok = [
  {
    value: ADS_CAMPAIGN_TIKTOK_CAMPAIGN_TYPE_WEBSITE_OPTION,
    label: CREATE_ADS_CAMPAIGN_TIKTOK_CAMPAIGN_TYPE_OPTION_WEBSITE,
  },
  {
    value: ADS_CAMPAIGN_TIKTOK_CAMPAIGN_TYPE_APP_OPTION,
    label: CREATE_ADS_CAMPAIGN_TIKTOK_CAMPAIGN_TYPE_OPTION_APP,
  },
];

export const optionsCallToActionAwarenessMeta = [
  { value: "LEARN_MORE", label: ADS_CAMPAIGN_CALL_TO_ACTION_LEARN_MORE },
  { value: "SEE_MENU", label: ADS_CAMPAIGN_CALL_TO_ACTION_SEE_MENU },
  { value: "SHOP_NOW", label: ADS_CAMPAIGN_CALL_TO_ACTION_SHOP_NOW },
  { value: "SIGN_UP", label: ADS_CAMPAIGN_CALL_TO_ACTION_SIGN_UP },
  { value: "SUBSCRIBE", label: ADS_CAMPAIGN_CALL_TO_ACTION_SUBSCRIBE },
  { value: "WATCH_MORE", label: ADS_CAMPAIGN_CALL_TO_ACTION_WATCH_MORE },
  { value: "APPLY_NOW", label: ADS_CAMPAIGN_CALL_TO_ACTION_APPLY_NOW },
  { value: "BOOK_NOW", label: ADS_CAMPAIGN_CALL_TO_ACTION_BOOK_NOW },
  // { value: "CONTACT_US", label: ADS_CAMPAIGN_CALL_TO_ACTION_CONTACT_US },
  { value: "DOWNLOAD", label: ADS_CAMPAIGN_CALL_TO_ACTION_DOWNLOAD },
  {
    value: "GET_DIRECTIONS",
    label: ADS_CAMPAIGN_CALL_TO_ACTION_GET_DIRECTIONS,
  },
  { value: "GET_QUOTE", label: ADS_CAMPAIGN_CALL_TO_ACTION_GET_QUOTE },
  { value: "GET_SHOWTIMES", label: ADS_CAMPAIGN_CALL_TO_ACTION_GET_SHOWTIMES },
  { value: "LISTEN_NOW", label: ADS_CAMPAIGN_CALL_TO_ACTION_LISTEN_NOW },
  { value: "ORDER_NOW", label: ADS_CAMPAIGN_CALL_TO_ACTION_ORDER_NOW },
];

export const optionsCallToActionTrafficMeta = [
  { value: "LEARN_MORE", label: ADS_CAMPAIGN_CALL_TO_ACTION_LEARN_MORE },
  { value: "GET_OFFER", label: ADS_CAMPAIGN_CALL_TO_ACTION_GET_OFFER },
  { value: "APPLY_NOW", label: ADS_CAMPAIGN_CALL_TO_ACTION_APPLY_NOW },
  { value: "BOOK_NOW", label: ADS_CAMPAIGN_CALL_TO_ACTION_BOOK_NOW },
  // { value: "CONTACT_US", label: ADS_CAMPAIGN_CALL_TO_ACTION_CONTACT_US },
  { value: "DOWNLOAD", label: ADS_CAMPAIGN_CALL_TO_ACTION_DOWNLOAD },
  { value: "GET_QUOTE", label: ADS_CAMPAIGN_CALL_TO_ACTION_GET_QUOTE },
  { value: "GET_SHOWTIMES", label: ADS_CAMPAIGN_CALL_TO_ACTION_GET_SHOWTIMES },
  { value: "LISTEN_NOW", label: ADS_CAMPAIGN_CALL_TO_ACTION_LISTEN_NOW },
  { value: "ORDER_NOW", label: ADS_CAMPAIGN_CALL_TO_ACTION_ORDER_NOW },
  { value: "SEE_MENU", label: ADS_CAMPAIGN_CALL_TO_ACTION_SEE_MENU },
  { value: "SHOP_NOW", label: ADS_CAMPAIGN_CALL_TO_ACTION_SHOP_NOW },
  { value: "SIGN_UP", label: ADS_CAMPAIGN_CALL_TO_ACTION_SIGN_UP },
  { value: "SUBSCRIBE", label: ADS_CAMPAIGN_CALL_TO_ACTION_SUBSCRIBE },
  { value: "WATCH_MORE", label: ADS_CAMPAIGN_CALL_TO_ACTION_WATCH_MORE },
];

export const optionsCallToActionEngagementMeta = [
  { value: "LEARN_MORE", label: ADS_CAMPAIGN_CALL_TO_ACTION_LEARN_MORE },
  { value: "SIGN_UP", label: ADS_CAMPAIGN_CALL_TO_ACTION_SIGN_UP },
  { value: "SUBSCRIBE", label: ADS_CAMPAIGN_CALL_TO_ACTION_SUBSCRIBE },
  { value: "APPLY_NOW", label: ADS_CAMPAIGN_CALL_TO_ACTION_APPLY_NOW },
  { value: "BOOK_NOW", label: ADS_CAMPAIGN_CALL_TO_ACTION_BOOK_NOW },
  // { value: "CONTACT_US", label: ADS_CAMPAIGN_CALL_TO_ACTION_CONTACT_US },
  { value: "GET_QUOTE", label: ADS_CAMPAIGN_CALL_TO_ACTION_GET_QUOTE },
  { value: "ORDER_NOW", label: ADS_CAMPAIGN_CALL_TO_ACTION_ORDER_NOW },
  { value: "SHOP_NOW", label: ADS_CAMPAIGN_CALL_TO_ACTION_SHOP_NOW },
];

export const optionsCallToActionEngagementMetaPost = [
  { value: "LEARN_MORE", label: ADS_CAMPAIGN_CALL_TO_ACTION_LEARN_MORE },
  { value: "GET_QUOTE", label: ADS_CAMPAIGN_CALL_TO_ACTION_GET_QUOTE },
  { value: "SHOP_NOW", label: ADS_CAMPAIGN_CALL_TO_ACTION_SHOP_NOW },
  // {
  //   value: ADS_CALL_TO_ACTION_SEND_MESSAGE_PAGE_META_VALUE,
  //   label: ADS_CAMPAIGN_CALL_TO_ACTION_SEND_MESSAGE,
  // },
];

export const optionsCallToActionLeadsMeta = [
  { value: "LEARN_MORE", label: ADS_CAMPAIGN_CALL_TO_ACTION_LEARN_MORE },
  { value: "APPLY_NOW", label: ADS_CAMPAIGN_CALL_TO_ACTION_APPLY_NOW },
  { value: "GET_OFFER", label: ADS_CAMPAIGN_CALL_TO_ACTION_GET_OFFER },
  { value: "BOOK_NOW", label: ADS_CAMPAIGN_CALL_TO_ACTION_BOOK_NOW },
  // { value: "CONTACT_US", label: ADS_CAMPAIGN_CALL_TO_ACTION_CONTACT_US },
  { value: "DOWNLOAD", label: ADS_CAMPAIGN_CALL_TO_ACTION_DOWNLOAD },
  { value: "GET_QUOTE", label: ADS_CAMPAIGN_CALL_TO_ACTION_GET_QUOTE },
  { value: "GET_SHOWTIMES", label: ADS_CAMPAIGN_CALL_TO_ACTION_GET_SHOWTIMES },
  { value: "LISTEN_NOW", label: ADS_CAMPAIGN_CALL_TO_ACTION_LISTEN_NOW },
  { value: "ORDER_NOW", label: ADS_CAMPAIGN_CALL_TO_ACTION_ORDER_NOW },
  { value: "PLAY_GAME", label: ADS_CAMPAIGN_CALL_TO_ACTION_PLAY_GAME },
  { value: "SEE_MENU", label: ADS_CAMPAIGN_CALL_TO_ACTION_SEE_MENU },
  { value: "SHOP_NOW", label: ADS_CAMPAIGN_CALL_TO_ACTION_SHOP_NOW },
  { value: "SIGN_UP", label: ADS_CAMPAIGN_CALL_TO_ACTION_SIGN_UP },
  { value: "SUBSCRIBE", label: ADS_CAMPAIGN_CALL_TO_ACTION_SUBSCRIBE },
  { value: "WATCH_MORE", label: ADS_CAMPAIGN_CALL_TO_ACTION_WATCH_MORE },
];

export const optionsCallToActionLeadsInstantFormMeta = [
  { value: "LEARN_MORE", label: ADS_CAMPAIGN_CALL_TO_ACTION_LEARN_MORE },
  { value: "SIGN_UP", label: ADS_CAMPAIGN_CALL_TO_ACTION_SIGN_UP },
  { value: "SUBSCRIBE", label: ADS_CAMPAIGN_CALL_TO_ACTION_SUBSCRIBE },
  { value: "APPLY_NOW", label: ADS_CAMPAIGN_CALL_TO_ACTION_APPLY_NOW },
  { value: "BOOK_NOW", label: ADS_CAMPAIGN_CALL_TO_ACTION_BOOK_NOW },
  { value: "DOWNLOAD", label: ADS_CAMPAIGN_CALL_TO_ACTION_DOWNLOAD },
  { value: "GET_OFFER", label: ADS_CAMPAIGN_CALL_TO_ACTION_GET_OFFER },
  { value: "GET_QUOTE", label: ADS_CAMPAIGN_CALL_TO_ACTION_GET_QUOTE },
];

export const optionsCallToActionAppPromotionMeta = [
  { value: "LEARN_MORE", label: ADS_CAMPAIGN_CALL_TO_ACTION_LEARN_MORE },
  {
    value: "INSTALL_MOBILE_APP",
    label: ADS_CAMPAIGN_CALL_TO_ACTION_INSTALL_NOW,
  },
  { value: "SHOP_NOW", label: ADS_CAMPAIGN_CALL_TO_ACTION_SHOP_NOW },
  { value: "SIGN_UP", label: ADS_CAMPAIGN_CALL_TO_ACTION_SIGN_UP },
  { value: "EXPLORE_MORE", label: ADS_CAMPAIGN_CALL_TO_ACTION_EXPLORE_MORE },
  { value: "SUBSCRIBE", label: ADS_CAMPAIGN_CALL_TO_ACTION_SUBSCRIBE },
  { value: "WATCH_MORE", label: ADS_CAMPAIGN_CALL_TO_ACTION_WATCH_MORE },
  { value: "PLAY_GAME", label: ADS_CAMPAIGN_CALL_TO_ACTION_PLAY_GAME },
  { value: "USE_MOBILE_APP", label: ADS_CAMPAIGN_CALL_TO_ACTION_USE_APP },
  { value: "BOOK_NOW", label: ADS_CAMPAIGN_CALL_TO_ACTION_BOOK_NOW },
  { value: "DOWNLOAD", label: ADS_CAMPAIGN_CALL_TO_ACTION_DOWNLOAD },
  { value: "ORDER_NOW", label: ADS_CAMPAIGN_CALL_TO_ACTION_ORDER_NOW },
];

export const optionsCallToActionSalesMeta = [
  { value: "LEARN_MORE", label: ADS_CAMPAIGN_CALL_TO_ACTION_LEARN_MORE },
  // { value: "PLAY_GAME", label: ADS_CAMPAIGN_CALL_TO_ACTION_PLAY_GAME },
  { value: "APPLY_NOW", label: ADS_CAMPAIGN_CALL_TO_ACTION_APPLY_NOW },
  { value: "BOOK_NOW", label: ADS_CAMPAIGN_CALL_TO_ACTION_BOOK_NOW },
  // { value: "CONTACT_US", label: ADS_CAMPAIGN_CALL_TO_ACTION_CONTACT_US },
  { value: "DOWNLOAD", label: ADS_CAMPAIGN_CALL_TO_ACTION_DOWNLOAD },
  { value: "GET_QUOTE", label: ADS_CAMPAIGN_CALL_TO_ACTION_GET_QUOTE },
  { value: "GET_SHOWTIMES", label: ADS_CAMPAIGN_CALL_TO_ACTION_GET_SHOWTIMES },
  { value: "LISTEN_NOW", label: ADS_CAMPAIGN_CALL_TO_ACTION_LISTEN_NOW },
  { value: "ORDER_NOW", label: ADS_CAMPAIGN_CALL_TO_ACTION_ORDER_NOW },
  { value: "SEE_MENU", label: ADS_CAMPAIGN_CALL_TO_ACTION_SEE_MENU },
  { value: "SHOP_NOW", label: ADS_CAMPAIGN_CALL_TO_ACTION_SHOP_NOW },
  { value: "SIGN_UP", label: ADS_CAMPAIGN_CALL_TO_ACTION_SIGN_UP },
  { value: "SUBSCRIBE", label: ADS_CAMPAIGN_CALL_TO_ACTION_SUBSCRIBE },
  { value: "WATCH_MORE", label: ADS_CAMPAIGN_CALL_TO_ACTION_WATCH_MORE },
  { value: "GET_OFFER", label: ADS_CAMPAIGN_CALL_TO_ACTION_GET_OFFER },
];

export const marksAge = [
  {
    value: 18,
    label: "18",
  },
  {
    value: 30,
    label: "30",
  },
  {
    value: 40,
    label: "40",
  },
  {
    value: 50,
    label: "50",
  },
  {
    value: 60,
    label: "60",
  },
];

export const optionsAdsCampaignTypeBudgets = [
  {
    value: ADS_CAMPAIGN_TYPE_BUDGET_DAILY_OPTION,
    label: ADS_CAMPAIGN_TYPE_BUDGET_DAILY,
    title: ADS_CAMPAIGN_TYPE_BUDGET_DAILY_TITLE_EXPLANATION,
    explanation: ADS_CAMPAIGN_TYPE_BUDGET_DAILY_DESCRIPTION_EXPLANATION,
  },
  {
    value: ADS_CAMPAIGN_TYPE_BUDGET_LIFETIME_OPTION,
    label: ADS_CAMPAIGN_TYPE_BUDGET_LIFETIME,
    title: ADS_CAMPAIGN_TYPE_BUDGET_TOTAL_TITLE_EXPLANATION,
    explanation: ADS_CAMPAIGN_TYPE_BUDGET_TOTAL_DESCRIPTION_EXPLANATION,
  },
];

export const optionsBuyingType = [
  {
    value: ADS_CAMPAIGN_BUYING_TYPE_AUCTION_OPTION,
    label: ADS_CAMPAIGN_BUYING_TYPE_AUCTION,
  },
  {
    value: ADS_CAMPAIGN_BUYING_TYPE_RESERVED_OPTION,
    label: ADS_CAMPAIGN_BUYING_TYPE_RESERVED,
  },
];

export const optionsAppPromotion = [
  {
    value: ADS_CAMPAIGN_APP_PROMOTION_ANDROID_OPTION,
    label: ADS_CAMPAIGN_APP_PROMOTION_ANDROID,
  },
  {
    value: ADS_CAMPAIGN_APP_PROMOTION_IOS_OPTION,
    label: ADS_CAMPAIGN_APP_PROMOTION_IOS,
  },
  {
    value: ADS_CAMPAIGN_APP_PROMOTION_BOTH_OPTION,
    label: ADS_CAMPAIGN_APP_PROMOTION_BOTH,
  },
];

export const optionsAdsCampaignTemplates = [
  {
    value: ADS_CAMPAIGN_TEMPLATE_SINGULAR_OPTION,
    label: CREATE_ADS_CAMPAIGN_TEMPLATE_SINGULAR,
  },
  {
    value: ADS_CAMPAIGN_TEMPLATE_MULTIPLE_OPTION,
    label: CREATE_ADS_CAMPAIGN_TEMPLATE_MULTIPLE,
  },
];

export const optionsLanguage = [
  { value: "en", label: ENGLISH },
  { value: "es", label: SPANISH },
  { value: "pt", label: PORTUGUESE },
  { value: "fr", label: FRENCH },
  { value: "it", label: ITALIAN },
  { value: "de", label: GERMAN },
  { value: "nl", label: DUTCH },
  { value: "da", label: DANISH },
  { value: "id", label: INDONESIAN },
  { value: "ru", label: RUSSIAN },
  { value: "ja", label: JAPANESE },
  { value: "zh", label: MANDARIN },
  { value: "hi", label: HINDI },
  { value: "ar", label: ARABIC },
  { value: "he", label: HEBREW },
  { value: "hu", label: HUNGARIAN },
  { value: "ko", label: KOREAN },
  { value: "bg", label: BULGARIAN },
  { value: "sk", label: SLOVAK },
  { value: "cs", label: CZECH },
  { value: "pl", label: POLISH },
  { value: "hr", label: CROATIAN },
  { value: "tr", label: TURKISH },
  { value: "uk", label: UKRAINIAN },
  { value: "zh-CN", label: CHINESE },
  { value: "el", label: GREEK },
];

export const optionsTikTokPrivacyLevel = [
  {
    value: "PUBLIC_TO_EVERYONE",
    label: TIKTOK_PRIVACY_LEVEL_PUBLIC_TO_EVERYONE,
  },
  {
    value: "MUTUAL_FOLLOW_FRIENDS",
    label: TIKTOK_PRIVACY_LEVEL_MUTUAL_FOLLOW_FRIENDS,
  },
  {
    value: "FOLLOWER_OF_CREATOR",
    label: TIKTOK_PRIVACY_LEVEL_FOLLOWER_OF_CREATOR,
  },
  { value: "SELF_ONLY", label: TIKTOK_PRIVACY_LEVEL_SELF_ONLY },
];

export const GENERIC_ACCENTS = {
  es: [
    { value: "spanish neutral", labelKey: ACCENT_ES_NEUTRAL },
    { value: "spanish argentine", labelKey: ACCENT_ES_ARGENTINO },
    { value: "spanish colombian", labelKey: ACCENT_ES_COLOMBIANO },
    { value: "spanish spain", labelKey: ACCENT_ES_ESPANOL_ESPANA },
    { value: "spanish chilean", labelKey: ACCENT_ES_CHILENO },
    { value: "spanish mexican", labelKey: ACCENT_ES_MEXICANO },
    // { value: "spanish peruvian", labelKey: ACCENT_ES_PERUANO },
    // { value: "spanish venezuelan", labelKey: ACCENT_ES_VENEZOLANO },
    // { value: "spanish caribbean", labelKey: ACCENT_ES_CARIBENO },
  ],

  en: [
    { value: "english american", labelKey: ACCENT_EN_AMERICAN },
    { value: "english british", labelKey: ACCENT_EN_BRITISH },
    { value: "english australian", labelKey: ACCENT_EN_AUSTRALIAN },
  ],
};

export const getDefaultAccentForLanguage = (languageCode) =>
  GENERIC_ACCENTS[languageCode]?.[0]?.value ?? null;

export const optionsCustomAudiencesMeta = [
  {
    value: ADS_CAMPAIGN_CUSTOM_AUDIENCE_TYPE_WEBSITE_OPTION,
    label: ADS_CAMPAIGN_CUSTOM_AUDIENCE_TYPE_WEBSITE,
    title: ADS_CAMPAIGNS_CUSTOM_AUDIENCE_TYPE_WEBSITE_TITLE_EXPLANATION,
    explanation:
      ADS_CAMPAIGNS_CUSTOM_AUDIENCE_TYPE_WEBSITE_DESCRIPTION_EXPLANATION,
  },
  {
    value: ADS_CAMPAIGN_CUSTOM_AUDIENCE_TYPE_CUSTOMER_LIST_OPTION,
    label: ADS_CAMPAIGN_CUSTOM_AUDIENCE_TYPE_CUSTOMER_LIST,
    title: ADS_CAMPAIGNS_CUSTOM_AUDIENCE_TYPE_CUSTOMER_LIST_TITLE_EXPLANATION,
    explanation:
      ADS_CAMPAIGNS_CUSTOM_AUDIENCE_TYPE_CUSTOMER_LIST_DESCRIPTION_EXPLANATION,
  },
];

export const optionsCallToActionAwarenessTikTokBusiness = [
  { value: "LEARN_MORE", label: ADS_CAMPAIGN_CALL_TO_ACTION_LEARN_MORE },
  { value: "DOWNLOAD_NOW", label: ADS_CAMPAIGN_CALL_TO_ACTION_DOWNLOAD },
  { value: "SHOP_NOW", label: ADS_CAMPAIGN_CALL_TO_ACTION_SHOP_NOW },
  { value: "SIGN_UP", label: ADS_CAMPAIGN_CALL_TO_ACTION_SIGN_UP },
  { value: "CONTACT_US", label: ADS_CAMPAIGN_CALL_TO_ACTION_CONTACT_US },
  { value: "APPLY_NOW", label: ADS_CAMPAIGN_CALL_TO_ACTION_APPLY_NOW },
  { value: "BOOK_NOW", label: ADS_CAMPAIGN_CALL_TO_ACTION_BOOK_NOW },
  { value: "PLAY_GAME", label: ADS_CAMPAIGN_CALL_TO_ACTION_PLAY_GAME },
  { value: "WATCH_NOW", label: ADS_CAMPAIGN_CALL_TO_ACTION_WATCH_NOW },
  { value: "READ_MORE", label: ADS_CAMPAIGN_CALL_TO_ACTION_READ_MORE },
  { value: "VIEW_NOW", label: ADS_CAMPAIGN_CALL_TO_ACTION_VIEW_NOW },
  { value: "GET_QUOTE", label: ADS_CAMPAIGN_CALL_TO_ACTION_GET_QUOTE },
  { value: "ORDER_NOW", label: ADS_CAMPAIGN_CALL_TO_ACTION_ORDER_NOW },
  { value: "INSTALL_NOW", label: ADS_CAMPAIGN_CALL_TO_ACTION_INSTALL_NOW },
  { value: "GET_SHOWTIMES", label: ADS_CAMPAIGN_CALL_TO_ACTION_GET_SHOWTIMES },
  { value: "LISTEN_NOW", label: ADS_CAMPAIGN_CALL_TO_ACTION_LISTEN_NOW },
  { value: "INTERESTED", label: ADS_CAMPAIGN_CALL_TO_ACTION_INTERESTED },
  { value: "SUBSCRIBE", label: ADS_CAMPAIGN_CALL_TO_ACTION_SUBSCRIBE },
  {
    value: "GET_TICKETS_NOW",
    label: ADS_CAMPAIGN_CALL_TO_ACTION_GET_TICKETS_NOW,
  },
  {
    value: "EXPERIENCE_NOW",
    label: ADS_CAMPAIGN_CALL_TO_ACTION_EXPERIENCE_NOW,
  },
  { value: "PREORDER_NOW", label: ADS_CAMPAIGN_CALL_TO_ACTION_PRE_ORDER_NOW },
  { value: "VISIT_STORE", label: ADS_CAMPAIGN_CALL_TO_ACTION_VISIT_STORE },
];

export const optionsCallToActionTrafficTikTokBusiness = [
  { value: "LEARN_MORE", label: ADS_CAMPAIGN_CALL_TO_ACTION_LEARN_MORE },
  { value: "INTERESTED", label: ADS_CAMPAIGN_CALL_TO_ACTION_INTERESTED },
  { value: "VISIT_STORE", label: ADS_CAMPAIGN_CALL_TO_ACTION_VISIT_STORE },
  { value: "WATCH_NOW", label: ADS_CAMPAIGN_CALL_TO_ACTION_WATCH_NOW },
  { value: "SIGN_UP", label: ADS_CAMPAIGN_CALL_TO_ACTION_SIGN_UP },
  { value: "LISTEN_NOW", label: ADS_CAMPAIGN_CALL_TO_ACTION_LISTEN_NOW },
  { value: "ORDER_NOW", label: ADS_CAMPAIGN_CALL_TO_ACTION_ORDER_NOW },
  { value: "BOOK_NOW", label: ADS_CAMPAIGN_CALL_TO_ACTION_BOOK_NOW },
  { value: "SHOP_NOW", label: ADS_CAMPAIGN_CALL_TO_ACTION_SHOP_NOW },
  { value: "PLAY_GAME", label: ADS_CAMPAIGN_CALL_TO_ACTION_PLAY_GAME },
  { value: "DOWNLOAD_NOW", label: ADS_CAMPAIGN_CALL_TO_ACTION_DOWNLOAD },
  { value: "CONTACT_US", label: ADS_CAMPAIGN_CALL_TO_ACTION_CONTACT_US },
  { value: "APPLY_NOW", label: ADS_CAMPAIGN_CALL_TO_ACTION_APPLY_NOW },
  { value: "READ_MORE", label: ADS_CAMPAIGN_CALL_TO_ACTION_READ_MORE },
  { value: "VIEW_NOW", label: ADS_CAMPAIGN_CALL_TO_ACTION_VIEW_NOW },
  { value: "GET_QUOTE", label: ADS_CAMPAIGN_CALL_TO_ACTION_GET_QUOTE },
  { value: "INSTALL_NOW", label: ADS_CAMPAIGN_CALL_TO_ACTION_INSTALL_NOW },
  { value: "GET_SHOWTIMES", label: ADS_CAMPAIGN_CALL_TO_ACTION_GET_SHOWTIMES },
  { value: "SUBSCRIBE", label: ADS_CAMPAIGN_CALL_TO_ACTION_SUBSCRIBE },
  {
    value: "GET_TICKETS_NOW",
    label: ADS_CAMPAIGN_CALL_TO_ACTION_GET_TICKETS_NOW,
  },
  {
    value: "EXPERIENCE_NOW",
    label: ADS_CAMPAIGN_CALL_TO_ACTION_EXPERIENCE_NOW,
  },
  { value: "PREORDER_NOW", label: ADS_CAMPAIGN_CALL_TO_ACTION_PRE_ORDER_NOW },
];

export const optionsCallToActionEngagementTikTokBusiness = [
  { value: "LEARN_MORE", label: ADS_CAMPAIGN_CALL_TO_ACTION_LEARN_MORE },
  { value: "DOWNLOAD_NOW", label: ADS_CAMPAIGN_CALL_TO_ACTION_DOWNLOAD },
  { value: "SHOP_NOW", label: ADS_CAMPAIGN_CALL_TO_ACTION_SHOP_NOW },
  { value: "SIGN_UP", label: ADS_CAMPAIGN_CALL_TO_ACTION_SIGN_UP },
  { value: "CONTACT_US", label: ADS_CAMPAIGN_CALL_TO_ACTION_CONTACT_US },
  { value: "APPLY_NOW", label: ADS_CAMPAIGN_CALL_TO_ACTION_APPLY_NOW },
  { value: "BOOK_NOW", label: ADS_CAMPAIGN_CALL_TO_ACTION_BOOK_NOW },
  { value: "PLAY_GAME", label: ADS_CAMPAIGN_CALL_TO_ACTION_PLAY_GAME },
  { value: "WATCH_NOW", label: ADS_CAMPAIGN_CALL_TO_ACTION_WATCH_NOW },
  { value: "READ_MORE", label: ADS_CAMPAIGN_CALL_TO_ACTION_READ_MORE },
  { value: "VIEW_NOW", label: ADS_CAMPAIGN_CALL_TO_ACTION_VIEW_NOW },
  { value: "GET_QUOTE", label: ADS_CAMPAIGN_CALL_TO_ACTION_GET_QUOTE },
  { value: "ORDER_NOW", label: ADS_CAMPAIGN_CALL_TO_ACTION_ORDER_NOW },
  { value: "INSTALL_NOW", label: ADS_CAMPAIGN_CALL_TO_ACTION_INSTALL_NOW },
  { value: "GET_SHOWTIMES", label: ADS_CAMPAIGN_CALL_TO_ACTION_GET_SHOWTIMES },
  { value: "LISTEN_NOW", label: ADS_CAMPAIGN_CALL_TO_ACTION_LISTEN_NOW },
  { value: "INTERESTED", label: ADS_CAMPAIGN_CALL_TO_ACTION_INTERESTED },
  { value: "SUBSCRIBE", label: ADS_CAMPAIGN_CALL_TO_ACTION_SUBSCRIBE },
  {
    value: "GET_TICKETS_NOW",
    label: ADS_CAMPAIGN_CALL_TO_ACTION_GET_TICKETS_NOW,
  },
  {
    value: "EXPERIENCE_NOW",
    label: ADS_CAMPAIGN_CALL_TO_ACTION_EXPERIENCE_NOW,
  },
  { value: "PREORDER_NOW", label: ADS_CAMPAIGN_CALL_TO_ACTION_PRE_ORDER_NOW },
  { value: "VISIT_STORE", label: ADS_CAMPAIGN_CALL_TO_ACTION_VISIT_STORE },
];

export const optionsCallToActionLeadsTikTokBusiness = [
  { value: "LEARN_MORE", label: ADS_CAMPAIGN_CALL_TO_ACTION_LEARN_MORE },
  { value: "INTERESTED", label: ADS_CAMPAIGN_CALL_TO_ACTION_INTERESTED },
  { value: "VISIT_STORE", label: ADS_CAMPAIGN_CALL_TO_ACTION_VISIT_STORE },
  { value: "WATCH_NOW", label: ADS_CAMPAIGN_CALL_TO_ACTION_WATCH_NOW },
  { value: "SIGN_UP", label: ADS_CAMPAIGN_CALL_TO_ACTION_SIGN_UP },
  { value: "LISTEN_NOW", label: ADS_CAMPAIGN_CALL_TO_ACTION_LISTEN_NOW },
  { value: "ORDER_NOW", label: ADS_CAMPAIGN_CALL_TO_ACTION_ORDER_NOW },
  { value: "BOOK_NOW", label: ADS_CAMPAIGN_CALL_TO_ACTION_BOOK_NOW },
  { value: "SHOP_NOW", label: ADS_CAMPAIGN_CALL_TO_ACTION_SHOP_NOW },
  { value: "PLAY_GAME", label: ADS_CAMPAIGN_CALL_TO_ACTION_PLAY_GAME },
  { value: "DOWNLOAD_NOW", label: ADS_CAMPAIGN_CALL_TO_ACTION_DOWNLOAD },
  { value: "CONTACT_US", label: ADS_CAMPAIGN_CALL_TO_ACTION_CONTACT_US },
  { value: "APPLY_NOW", label: ADS_CAMPAIGN_CALL_TO_ACTION_APPLY_NOW },
  { value: "READ_MORE", label: ADS_CAMPAIGN_CALL_TO_ACTION_READ_MORE },
  { value: "VIEW_NOW", label: ADS_CAMPAIGN_CALL_TO_ACTION_VIEW_NOW },
  { value: "GET_QUOTE", label: ADS_CAMPAIGN_CALL_TO_ACTION_GET_QUOTE },
  { value: "INSTALL_NOW", label: ADS_CAMPAIGN_CALL_TO_ACTION_INSTALL_NOW },
  { value: "GET_SHOWTIMES", label: ADS_CAMPAIGN_CALL_TO_ACTION_GET_SHOWTIMES },
  { value: "SUBSCRIBE", label: ADS_CAMPAIGN_CALL_TO_ACTION_SUBSCRIBE },
  {
    value: "GET_TICKETS_NOW",
    label: ADS_CAMPAIGN_CALL_TO_ACTION_GET_TICKETS_NOW,
  },
  {
    value: "EXPERIENCE_NOW",
    label: ADS_CAMPAIGN_CALL_TO_ACTION_EXPERIENCE_NOW,
  },
  { value: "PREORDER_NOW", label: ADS_CAMPAIGN_CALL_TO_ACTION_PRE_ORDER_NOW },
];

export const optionsCallToActionAppPromotionTikTokBusiness = [
  { value: "LEARN_MORE", label: ADS_CAMPAIGN_CALL_TO_ACTION_LEARN_MORE },
  { value: "WATCH_NOW", label: ADS_CAMPAIGN_CALL_TO_ACTION_WATCH_NOW },
  { value: "SIGN_UP", label: ADS_CAMPAIGN_CALL_TO_ACTION_SIGN_UP },
  { value: "LISTEN_NOW", label: ADS_CAMPAIGN_CALL_TO_ACTION_LISTEN_NOW },
  { value: "ORDER_NOW", label: ADS_CAMPAIGN_CALL_TO_ACTION_ORDER_NOW },
  { value: "BOOK_NOW", label: ADS_CAMPAIGN_CALL_TO_ACTION_BOOK_NOW },
  { value: "INSTALL_NOW", label: ADS_CAMPAIGN_CALL_TO_ACTION_INSTALL_NOW },
  { value: "SHOP_NOW", label: ADS_CAMPAIGN_CALL_TO_ACTION_SHOP_NOW },
  { value: "PLAY_GAME", label: ADS_CAMPAIGN_CALL_TO_ACTION_PLAY_GAME },
  { value: "DOWNLOAD_NOW", label: ADS_CAMPAIGN_CALL_TO_ACTION_DOWNLOAD },
  { value: "CONTACT_US", label: ADS_CAMPAIGN_CALL_TO_ACTION_CONTACT_US },
  { value: "APPLY_NOW", label: ADS_CAMPAIGN_CALL_TO_ACTION_APPLY_NOW },
  { value: "READ_MORE", label: ADS_CAMPAIGN_CALL_TO_ACTION_READ_MORE },
  { value: "VIEW_NOW", label: ADS_CAMPAIGN_CALL_TO_ACTION_VIEW_NOW },
  { value: "GET_QUOTE", label: ADS_CAMPAIGN_CALL_TO_ACTION_GET_QUOTE },
  { value: "GET_SHOWTIMES", label: ADS_CAMPAIGN_CALL_TO_ACTION_GET_SHOWTIMES },
  { value: "INTERESTED", label: ADS_CAMPAIGN_CALL_TO_ACTION_INTERESTED },
  { value: "SUBSCRIBE", label: ADS_CAMPAIGN_CALL_TO_ACTION_SUBSCRIBE },
  {
    value: "GET_TICKETS_NOW",
    label: ADS_CAMPAIGN_CALL_TO_ACTION_GET_TICKETS_NOW,
  },
  {
    value: "EXPERIENCE_NOW",
    label: ADS_CAMPAIGN_CALL_TO_ACTION_EXPERIENCE_NOW,
  },
  { value: "PREORDER_NOW", label: ADS_CAMPAIGN_CALL_TO_ACTION_PRE_ORDER_NOW },
];

export const optionsCallToActionSalesTikTokBusiness = [
  { value: "LEARN_MORE", label: ADS_CAMPAIGN_CALL_TO_ACTION_LEARN_MORE },
  { value: "INTERESTED", label: ADS_CAMPAIGN_CALL_TO_ACTION_INTERESTED },
  { value: "VISIT_STORE", label: ADS_CAMPAIGN_CALL_TO_ACTION_VISIT_STORE },
  { value: "WATCH_NOW", label: ADS_CAMPAIGN_CALL_TO_ACTION_WATCH_NOW },
  { value: "SIGN_UP", label: ADS_CAMPAIGN_CALL_TO_ACTION_SIGN_UP },
  { value: "LISTEN_NOW", label: ADS_CAMPAIGN_CALL_TO_ACTION_LISTEN_NOW },
  { value: "ORDER_NOW", label: ADS_CAMPAIGN_CALL_TO_ACTION_ORDER_NOW },
  { value: "BOOK_NOW", label: ADS_CAMPAIGN_CALL_TO_ACTION_BOOK_NOW },
  { value: "SHOP_NOW", label: ADS_CAMPAIGN_CALL_TO_ACTION_SHOP_NOW },
  { value: "PLAY_GAME", label: ADS_CAMPAIGN_CALL_TO_ACTION_PLAY_GAME },
  { value: "DOWNLOAD_NOW", label: ADS_CAMPAIGN_CALL_TO_ACTION_DOWNLOAD },
  { value: "CONTACT_US", label: ADS_CAMPAIGN_CALL_TO_ACTION_CONTACT_US },
  { value: "APPLY_NOW", label: ADS_CAMPAIGN_CALL_TO_ACTION_APPLY_NOW },
  { value: "READ_MORE", label: ADS_CAMPAIGN_CALL_TO_ACTION_READ_MORE },
  { value: "VIEW_NOW", label: ADS_CAMPAIGN_CALL_TO_ACTION_VIEW_NOW },
  { value: "GET_QUOTE", label: ADS_CAMPAIGN_CALL_TO_ACTION_GET_QUOTE },
  { value: "INSTALL_NOW", label: ADS_CAMPAIGN_CALL_TO_ACTION_INSTALL_NOW },
  { value: "GET_SHOWTIMES", label: ADS_CAMPAIGN_CALL_TO_ACTION_GET_SHOWTIMES },
  { value: "SUBSCRIBE", label: ADS_CAMPAIGN_CALL_TO_ACTION_SUBSCRIBE },
  {
    value: "GET_TICKETS_NOW",
    label: ADS_CAMPAIGN_CALL_TO_ACTION_GET_TICKETS_NOW,
  },
  {
    value: "EXPERIENCE_NOW",
    label: ADS_CAMPAIGN_CALL_TO_ACTION_EXPERIENCE_NOW,
  },
  { value: "PREORDER_NOW", label: ADS_CAMPAIGN_CALL_TO_ACTION_PRE_ORDER_NOW },
];

export const optionsCustomEventsEngagement = [
  {
    value: "ADD_TO_WISHLIST",
    label: ADS_CAMPAIGN_CUSTOM_EVENT_ADD_TO_WISHLIST,
  },
  { value: "CONTACT", label: ADS_CAMPAIGN_CUSTOM_EVENT_CONTACT },
  {
    value: "CUSTOMIZE_PRODUCT",
    label: ADS_CAMPAIGN_CUSTOM_EVENT_CUSTOMIZE_PRODUCT,
  },
  { value: "DONATE", label: ADS_CAMPAIGN_CUSTOM_EVENT_DONATE },
  { value: "FIND_LOCATION", label: ADS_CAMPAIGN_CUSTOM_EVENT_FIND_LOCATION },
  { value: "SCHEDULE", label: ADS_CAMPAIGN_CUSTOM_EVENT_SCHEDULE },
  { value: "SEARCH", label: ADS_CAMPAIGN_CUSTOM_EVENT_SEARCH },
  { value: "START_TRIAL", label: ADS_CAMPAIGN_CUSTOM_EVENT_START_TRIAL },
  {
    value: "SUBMIT_APPLICATION",
    label: ADS_CAMPAIGN_CUSTOM_EVENT_SUBMIT_APPLICATION,
  },
  { value: "SUBSCRIBE", label: ADS_CAMPAIGN_CUSTOM_EVENT_SUBSCRIBE },
  { value: "CONTENT_VIEW", label: ADS_CAMPAIGN_CUSTOM_EVENT_CONTENT_VIEW },
];

export const optionsCustomEventsLeadsMeta = [
  {
    value: "COMPLETE_REGISTRATION",
    label: ADS_CAMPAIGN_CUSTOM_EVENT_COMPLETE_REGISTRATION,
  },
  { value: "CONTACT", label: ADS_CAMPAIGN_CUSTOM_EVENT_CONTACT },
  { value: "FIND_LOCATION", label: ADS_CAMPAIGN_CUSTOM_EVENT_FIND_LOCATION },
  { value: "LEAD", label: ADS_CAMPAIGN_CUSTOM_EVENT_LEAD },
  { value: "SCHEDULE", label: ADS_CAMPAIGN_CUSTOM_EVENT_SCHEDULE },
  { value: "SEARCH", label: ADS_CAMPAIGN_CUSTOM_EVENT_SEARCH },
  { value: "START_TRIAL", label: ADS_CAMPAIGN_CUSTOM_EVENT_START_TRIAL },
  {
    value: "SUBMIT_APPLICATION",
    label: ADS_CAMPAIGN_CUSTOM_EVENT_SUBMIT_APPLICATION,
  },
  { value: "SUBSCRIBE", label: ADS_CAMPAIGN_CUSTOM_EVENT_SUBSCRIBE },
  { value: "CONTENT_VIEW", label: ADS_CAMPAIGN_CUSTOM_EVENT_CONTENT_VIEW },
];
export const optionsCustomEventSalesCatalogMeta = [
  { value: "ADD_TO_CART", label: ADS_CAMPAIGN_CUSTOM_EVENT_ADD_TO_CART },
  {
    value: "ADD_TO_WISHLIST",
    label: ADS_CAMPAIGN_CUSTOM_EVENT_ADD_TO_WISHLIST,
  },
  {
    value: "COMPLETE_REGISTRATION",
    label: ADS_CAMPAIGN_CUSTOM_EVENT_COMPLETE_REGISTRATION,
  },
  {
    value: "INITIATED_CHECKOUT",
    label: ADS_CAMPAIGN_CUSTOM_EVENT_INITIATED_CHECKOUT,
  },
  { value: "LEAD", label: ADS_CAMPAIGN_CUSTOM_EVENT_LEAD },
  { value: "PURCHASE", label: ADS_CAMPAIGN_CUSTOM_EVENT_PURCHASE },
  { value: "SEARCH", label: ADS_CAMPAIGN_CUSTOM_EVENT_SEARCH },
  { value: "CONTENT_VIEW", label: ADS_CAMPAIGN_CUSTOM_EVENT_CONTENT_VIEW },
];
export const optionsCustomEventSalesMeta = [
  {
    value: "ADD_PAYMENT_INFO",
    label: ADS_CAMPAIGN_CUSTOM_EVENT_ADD_PAYMENT_INFO,
  },
  { value: "ADD_TO_CART", label: ADS_CAMPAIGN_CUSTOM_EVENT_ADD_TO_CART },
  {
    value: "ADD_TO_WISHLIST",
    label: ADS_CAMPAIGN_CUSTOM_EVENT_ADD_TO_WISHLIST,
  },
  {
    value: "COMPLETE_REGISTRATION",
    label: ADS_CAMPAIGN_CUSTOM_EVENT_COMPLETE_REGISTRATION,
  },
  { value: "DONATE", label: ADS_CAMPAIGN_CUSTOM_EVENT_DONATE },
  {
    value: "INITIATED_CHECKOUT",
    label: ADS_CAMPAIGN_CUSTOM_EVENT_INITIATED_CHECKOUT,
  },
  { value: "PURCHASE", label: ADS_CAMPAIGN_CUSTOM_EVENT_PURCHASE },
  { value: "SEARCH", label: ADS_CAMPAIGN_CUSTOM_EVENT_SEARCH },
  { value: "START_TRIAL", label: ADS_CAMPAIGN_CUSTOM_EVENT_START_TRIAL },
  { value: "SUBSCRIBE", label: ADS_CAMPAIGN_CUSTOM_EVENT_SUBSCRIBE },
  { value: "CONTENT_VIEW", label: ADS_CAMPAIGN_CUSTOM_EVENT_CONTENT_VIEW },
];

export const optionsCustomEventsLeadsTikTok = [
  {
    value: "ON_WEB_ADD_TO_WISHLIST",
    label: ADS_CAMPAIGN_CUSTOM_EVENT_ADD_TO_WISHLIST,
  },
  { value: "ON_WEB_SEARCH", label: ADS_CAMPAIGN_CUSTOM_EVENT_SEARCH },
  { value: "BUTTON", label: ADS_CAMPAIGN_CUSTOM_EVENT_CLICK_BUTTON },
  { value: "CONSULT", label: ADS_CAMPAIGN_CUSTOM_EVENT_CONTACT },
  { value: "FORM", label: ADS_CAMPAIGN_CUSTOM_EVENT_SUBMIT_FORM },
  {
    value: "ON_WEB_REGISTER",
    label: ADS_CAMPAIGN_CUSTOM_EVENT_COMPLETE_REGISTRATION,
  },
  { value: "ON_WEB_SUBSCRIBE", label: ADS_CAMPAIGN_CUSTOM_EVENT_SUBSCRIBE },
  { value: "ON_WEB_DETAIL", label: ADS_CAMPAIGN_CUSTOM_EVENT_CONTENT_VIEW },
];
export const optionsCustomEventsSalesTikTok = [
  {
    value: "SHOPPING",
    label: ADS_CAMPAIGN_CUSTOM_EVENT_PURCHASE,
  },
  {
    value: "ON_WEB_CART",
    label: ADS_CAMPAIGN_CUSTOM_EVENT_ADD_TO_CART,
  },
  {
    value: "ADD_BILLING",
    label: ADS_CAMPAIGN_CUSTOM_EVENT_ADD_PAYMENT_INFO,
  },
  {
    value: "ON_WEB_ORDER",
    label: ADS_CAMPAIGN_CUSTOM_EVENT_PLACE_ORDER,
  },
  {
    value: "ON_WEB_ADD_TO_WISHLIST",
    label: ADS_CAMPAIGN_CUSTOM_EVENT_ADD_TO_WISHLIST,
  },
  { value: "ON_WEB_SEARCH", label: ADS_CAMPAIGN_CUSTOM_EVENT_SEARCH },
  { value: "BUTTON", label: ADS_CAMPAIGN_CUSTOM_EVENT_CLICK_BUTTON },
  { value: "CONSULT", label: ADS_CAMPAIGN_CUSTOM_EVENT_CONTACT },
  {
    value: "ON_WEB_REGISTER",
    label: ADS_CAMPAIGN_CUSTOM_EVENT_COMPLETE_REGISTRATION,
  },
  { value: "ON_WEB_SUBSCRIBE", label: ADS_CAMPAIGN_CUSTOM_EVENT_SUBSCRIBE },
  { value: "ON_WEB_DETAIL", label: ADS_CAMPAIGN_CUSTOM_EVENT_CONTENT_VIEW },
];
export const optionsAppEventsTikTok = [
  {
    value: "ACTIVE",
    label: ADS_TIKTOK_APP_EVENT_ACTIVE_OPTION,
  },
  {
    value: "DOWNLOAD_START",
    label: ADS_TIKTOK_APP_EVENT_DOWNLOAD_START_OPTION,
  },
  {
    value: "ACTIVE_REGISTER",
    label: ADS_TIKTOK_APP_EVENT_ACTIVE_REGISTER_OPTION,
  },
  {
    value: "ACTIVE_PAY",
    label: ADS_TIKTOK_APP_EVENT_ACTIVE_PAY_OPTION,
  },
  {
    value: "IN_APP_ORDER",
    label: ADS_TIKTOK_APP_EVENT_IN_APP_ORDER_OPTION,
  },
  {
    value: "IN_APP_CART",
    label: ADS_TIKTOK_APP_EVENT_IN_APP_CART_OPTION,
  },
  {
    value: "IN_APP_DETAIL_UV",
    label: ADS_TIKTOK_APP_EVENT_IN_APP_DETAIL_UV_OPTION,
  },
  {
    value: "NEXT_DAY_OPEN",
    label: ADS_TIKTOK_APP_EVENT_NEXT_DAY_OPEN_OPTION,
  },
  {
    value: "LOGIN",
    label: ADS_TIKTOK_APP_EVENT_LOGIN_OPTION,
  },
  {
    value: "LAUNCH_APP",
    label: ADS_TIKTOK_APP_EVENT_LAUNCH_APP_OPTION,
  },
  {
    value: "COMPLETE_TUTORIAL",
    label: ADS_TIKTOK_APP_EVENT_COMPLETE_TUTORIAL_OPTION,
  },
  {
    value: "SEARCH",
    label: ADS_TIKTOK_APP_EVENT_SEARCH_OPTION,
  },
  {
    value: "START_TRIAL",
    label: ADS_TIKTOK_APP_EVENT_START_TRIAL_OPTION,
  },
  {
    value: "SUBSCRIBE",
    label: ADS_TIKTOK_APP_EVENT_SUBSCRIBE_OPTION,
  },
];

export const optionsCampaignsTypeGoogleAds = [
  {
    value: ADS_CAMPAIGN_TYPE_SEARCH_OPTION,
    label: ADS_CAMPAIGN_TYPE_SEARCH,
    title: ADS_CAMPAIGN_TYPE_SEARCH_TITLE_EXPLANATION,
    explanation: ADS_CAMPAIGN_TYPE_SEARCH_DESCRIPTION_EXPLANATION,
  },
  {
    value: ADS_CAMPAIGN_TYPE_PERFORMANCE_MAX_OPTION,
    label: ADS_CAMPAIGN_TYPE_PERFORMANCE_MAX,
    title: ADS_CAMPAIGN_TYPE_PERFORMANCE_MAX_TITLE_EXPLANATION,
    explanation: ADS_CAMPAIGN_TYPE_PERFORMANCE_MAX_DESCRIPTION_EXPLANATION,
  },
  {
    value: ADS_CAMPAIGN_TYPE_APP_OPTION,
    label: ADS_CAMPAIGN_TYPE_APP,
    title: ADS_CAMPAIGN_TYPE_APP_TITLE_EXPLANATION,
    explanation: ADS_CAMPAIGN_TYPE_APP_DESCRIPTION_EXPLANATION,
  },
  // {
  //   value: ADS_CAMPAIGN_TYPE_SHOPPING_OPTION,
  //   label: ADS_CAMPAIGN_TYPE_SHOPPING,
  //   title: ADS_CAMPAIGN_TYPE_SHOPPING_TITLE_EXPLANATION,
  //   explanation: ADS_CAMPAIGN_TYPE_SHOPPING_DESCRIPTION_EXPLANATION,
  // },
  // {
  //   value: ADS_CAMPAIGN_TYPE_VIDEO_OPTION,
  //   label: ADS_CAMPAIGN_TYPE_VIDEO,
  //   title: ADS_CAMPAIGN_TYPE_VIDEO_TITLE_EXPLANATION,
  //   explanation: ADS_CAMPAIGN_TYPE_VIDEO_DESCRIPTION_EXPLANATION,
  // },
];

export const optionsGoogleSearchAdGroupType = [
  {
    value: ADS_GOOGLE_SEARCH_AD_GROUP_TYPE_STANDARD_OPTION,
    label: GOOGLE_SEARCH_AD_GROUP_TYPE_STANDARD,
  },
  {
    value: ADS_GOOGLE_SEARCH_AD_GROUP_TYPE_DSA_OPTION,
    label: GOOGLE_SEARCH_AD_GROUP_TYPE_DSA,
  },
];

export const optionsGoogleWebpageCriterionOperators = [
  {
    value: ADS_GOOGLE_WEBPAGE_CRITERION_URL_EQUALS_OPTION,
    label: GOOGLE_WEBPAGE_CRITERION_URL_EQUALS,
  },
  {
    value: ADS_GOOGLE_WEBPAGE_CRITERION_URL_CONTAINS_OPTION,
    label: GOOGLE_WEBPAGE_CRITERION_URL_CONTAINS,
  },
];

export const optionsMetaDestinationTypeTrafficObjective = [
  {
    value: ADS_CAMPAIGN_META_DESTINATION_TYPE_WEBSITE_OPTION,
    label: ADS_META_DESTINATION_TYPE_WEBSITE,
  },
  {
    value: ADS_CAMPAIGN_META_DESTINATION_TYPE_WHATSAPP_OPTION,
    label: ADS_META_DESTINATION_TYPE_WHATSAPP,
  },
  {
    value: ADS_CAMPAIGN_META_DESTINATION_TYPE_INSTAGRAM_PROFILE_OPTION,
    label: ADS_META_DESTINATION_TYPE_INSTAGRAM_PROFILE,
  },
  {
    value: ADS_CAMPAIGN_META_DESTINATION_TYPE_MESSAGES_ON_INSTAGRAM_OPTION,
    label: ADS_META_DESTINATION_TYPE_MESSAGES_ON_INSTAGRAM,
  },
  {
    value: ADS_CAMPAIGN_META_DESTINATION_TYPE_MESSAGES_ON_MESSAGE_OPTION,
    label: ADS_META_DESTINATION_TYPE_MESSAGES_ON_MESSENGER,
  },
  {
    value:
      ADS_CAMPAIGN_META_DESTINATION_TYPE_MESSAGES_ON_INSTAGRAM_AND_MESSENGER_OPTION,
    label: ADS_META_DESTINATION_TYPE_MESSAGES_ON_INSTAGRAM_AND_MESSENGER,
  },
];

export const optionsMetaOptimizationGoalAwareness = [
  {
    value: ADS_CAMPAIGN_META_OPTIMIZATION_GOAL_REACH,
    label: OPTIMIZATION_GOAL_OPTION_REACH,
  },
  {
    value: ADS_CAMPAIGN_META_OPTIMIZATION_GOAL_THRUPLAY,
    label: OPTIMIZATION_GOAL_OPTION_THRUPLAY,
  },
];

export const optionsMetaOptimizationGoalTrafficWebsite = [
  {
    value: ADS_CAMPAIGN_META_OPTIMIZATION_GOAL_LINK_CLICKS,
    label: OPTIMIZATION_GOAL_OPTION_LINK_CLICKS,
  },
  {
    value: ADS_CAMPAIGN_META_OPTIMIZATION_GOAL_LANDING_PAGE_VIEWS,
    label: OPTIMIZATION_GOAL_OPTION_LANDING_PAGE_VIEWS,
  },
];

export const optionsAdsRoles = [
  {
    value: ADVERTISER_ROLE,
    label: ADVERTISER,
  },
  {
    value: MARKETER_ROLE,
    label: MARKETER,
  },
  {
    value: DESIGNER_ROLE,
    label: DESIGNER,
  },
  {
    value: VIEWER_ROLE,
    label: VIEWER,
  },
];

export const optionsMetaDestinationTypeEngagementObjective = [
  {
    value: ADS_CAMPAIGN_META_DESTINATION_TYPE_WEBSITE_OPTION,
    label: ADS_META_DESTINATION_TYPE_WEBSITE,
  },
  {
    value: ADS_CAMPAIGN_META_DESTINATION_TYPE_WHATSAPP_OPTION,
    label: ADS_META_DESTINATION_TYPE_WHATSAPP,
  },
  {
    value: ADS_CAMPAIGN_META_DESTINATION_TYPE_ON_POST_OPTION,
    label: ADS_META_DESTINATION_TYPE_ON_POST,
  },
  {
    value: ADS_CAMPAIGN_META_DESTINATION_TYPE_ON_VIDEO_OPTION,
    label: ADS_META_DESTINATION_TYPE_ON_VIDEO,
  },
  {
    value: ADS_CAMPAIGN_META_DESTINATION_TYPE_MESSAGES_ON_INSTAGRAM_OPTION,
    label: ADS_META_DESTINATION_TYPE_MESSAGES_ON_INSTAGRAM,
  },
  {
    value: ADS_CAMPAIGN_META_DESTINATION_TYPE_MESSAGES_ON_MESSAGE_OPTION,
    label: ADS_META_DESTINATION_TYPE_MESSAGES_ON_MESSENGER,
  },
  {
    value:
      ADS_CAMPAIGN_META_DESTINATION_TYPE_MESSAGES_ON_INSTAGRAM_AND_MESSENGER_OPTION,
    label: ADS_META_DESTINATION_TYPE_MESSAGES_ON_INSTAGRAM_AND_MESSENGER,
  },
];

export const optionsMetaDestinationTypeLeadsObjective = [
  {
    value: ADS_CAMPAIGN_META_DESTINATION_TYPE_WEBSITE_OPTION,
    label: ADS_META_DESTINATION_TYPE_WEBSITE,
  },
  {
    value: ADS_CAMPAIGN_META_DESTINATION_TYPE_LEAD_INSTANT_FORM_OPTION,
    label: ADS_META_DESTINATION_TYPE_INSTANT_FORM,
  },
  {
    value: ADS_CAMPAIGN_META_DESTINATION_TYPE_WHATSAPP_OPTION,
    label: ADS_META_DESTINATION_TYPE_WHATSAPP,
  },
  // {
  //   value: ADS_CAMPAIGN_META_DESTINATION_TYPE_LEAD_FROM_IG_DIRECT_OPTION,
  //   label: ADS_META_DESTINATION_TYPE_MESSAGES_ON_INSTAGRAM,
  // },
  // {
  //   value: ADS_CAMPAIGN_META_DESTINATION_TYPE_MESSAGES_ON_MESSAGE_OPTION,
  //   label: ADS_META_DESTINATION_TYPE_MESSAGES_ON_MESSENGER,
  // },
];
export const optionsMetaDestinationTypeSalesObjective = [
  {
    value: ADS_CAMPAIGN_META_DESTINATION_TYPE_WEBSITE_OPTION,
    label: ADS_META_DESTINATION_TYPE_WEBSITE,
  },
  {
    value: ADS_CAMPAIGN_META_DESTINATION_TYPE_WHATSAPP_OPTION,
    label: ADS_META_DESTINATION_TYPE_WHATSAPP,
  },
  {
    value: ADS_CAMPAIGN_META_DESTINATION_TYPE_WEBSITE_AND_IN_STORE_OPTION,
    label: ADS_META_DESTINATION_TYPE_WEBSITE_AND_IN_STORE,
  },
  {
    value: ADS_CAMPAIGN_META_DESTINATION_TYPE_WEBSITE_AND_APP_OPTION,
    label: ADS_META_DESTINATION_TYPE_WEBSITE_AND_APP,
  },
  {
    value: ADS_CAMPAIGN_META_DESTINATION_TYPE_WEBSITE_APP_AND_IN_STORE_OPTION,
    label: ADS_META_DESTINATION_TYPE_WEBSITE_APP_AND_IN_STORE,
  },
  {
    value: ADS_CAMPAIGN_META_DESTINATION_TYPE_GOOGLE_PLAY_OPTION,
    label: ADS_META_DESTINATION_TYPE_GOOGLE_PLAY,
  },
  {
    value: ADS_CAMPAIGN_META_DESTINATION_TYPE_APP_STORE_OPTION,
    label: ADS_META_DESTINATION_TYPE_APP_STORE,
  },
];
export const optionsMetaCampaignDestinationTypeSalesObjective = [
  {
    value: ADS_CAMPAIGN_META_DESTINATION_TYPE_WEBSITE_OPTION,
    label: ADS_META_DESTINATION_TYPE_WEBSITE,
  },
  {
    value: ADS_CAMPAIGN_META_DESTINATION_TYPE_WHATSAPP_OPTION,
    label: ADS_META_DESTINATION_TYPE_WHATSAPP,
  },
  {
    value: ADS_CAMPAIGN_META_DESTINATION_TYPE_WEBSITE_AND_IN_STORE_OPTION,
    label: ADS_META_DESTINATION_TYPE_WEBSITE_AND_IN_STORE,
  },
  {
    value: ADS_CAMPAIGN_META_DESTINATION_TYPE_WEBSITE_AND_APP_OPTION,
    label: ADS_META_DESTINATION_TYPE_WEBSITE_AND_APP,
  },
  {
    value: ADS_CAMPAIGN_META_DESTINATION_TYPE_WEBSITE_APP_AND_IN_STORE_OPTION,
    label: ADS_META_DESTINATION_TYPE_WEBSITE_APP_AND_IN_STORE,
  },
  {
    value: ADS_CAMPAIGN_META_DESTINATION_TYPE_CATALOG_OPTION,
    label: ADS_META_DESTINATION_TYPE_CATALOG,
  },
  {
    value: ADS_CAMPAIGN_META_DESTINATION_TYPE_APP_OPTION,
    label: ADS_META_DESTINATION_TYPE_APP,
  },
];
export const optionsMetaDestinationTypeAppPromotionObjective = [
  {
    value: ADS_CAMPAIGN_META_DESTINATION_TYPE_GOOGLE_PLAY_OPTION,
    label: ADS_META_DESTINATION_TYPE_GOOGLE_PLAY,
  },
  {
    value: ADS_CAMPAIGN_META_DESTINATION_TYPE_APP_STORE_OPTION,
    label: ADS_META_DESTINATION_TYPE_APP_STORE,
  },
];

export const optionsAdsCampaignBreakdownsReport = [
  {
    value: "daily",
    label: ADS_CAMPAIGN_REPORT_BREAKDOWN_DAILY,
  },
  {
    value: "weekly",
    label: ADS_CAMPAIGN_REPORT_BREAKDOWN_WEEKLY,
  },
  {
    value: "monthly",
    label: ADS_CAMPAIGN_REPORT_BREAKDOWN_MONTHLY,
  },
];

export const optionsKeywordMatchType = [
  {
    value: "broad",
    label: KEYWORD_BROAD_MATCH_TYPE_OPTION,
  },
  {
    value: "phrase",
    label: KEYWORD_PHRASE_MATCH_TYPE_OPTION,
  },
  {
    value: "exact",
    label: KEYWORD_EXACT_MATCH_TYPE_OPTION,
  },
];

export const PRODUCTS_CATEGORIES_GOOGLE = [
  { value: "LEVEL1~1", label: CATEGORY_ANIMALS_PET_SUPPLIES },
  { value: "LEVEL1~8", label: CATEGORY_ARTS_ENTERTAINMENT },
  { value: "LEVEL1~111", label: CATEGORY_BUSINESS_INDUSTRIAL },
  { value: "LEVEL1~141", label: CATEGORY_CAMERAS_OPTICS },
  { value: "LEVEL1~166", label: CATEGORY_CLOTHING_ACCESSORIES },
  { value: "LEVEL1~222", label: CATEGORY_ELECTRONICS },
  { value: "LEVEL1~412", label: CATEGORY_FOOD_BEVERAGES },
  { value: "LEVEL1~436", label: CATEGORY_FURNITURE },
  { value: "LEVEL1~469", label: CATEGORY_HEALTH_BEAUTY },
  { value: "LEVEL1~536", label: CATEGORY_HOME_GARDEN },
  { value: "LEVEL1~537", label: CATEGORY_BABY_TODDLER },
  { value: "LEVEL1~632", label: CATEGORY_HARDWARE },
  { value: "LEVEL1~772", label: CATEGORY_MATURE },
  { value: "LEVEL1~783", label: CATEGORY_MEDIA },
  { value: "LEVEL1~888", label: CATEGORY_VEHICLES_PARTS },
  { value: "LEVEL1~922", label: CATEGORY_OFFICE_SUPPLIES },
  { value: "LEVEL1~988", label: CATEGORY_SPORTING_GOODS },
  { value: "LEVEL1~1239", label: CATEGORY_TOYS_GAMES },
  { value: "LEVEL1~2092", label: CATEGORY_SOFTWARE },
  { value: "LEVEL1~5181", label: CATEGORY_LUGGAGE_BAGS },
  { value: "LEVEL1~5605", label: CATEGORY_RELIGIOUS_CEREMONIAL },
];

export const optionsDestinationFallback = [
  {
    value: ADS_CAMPAIGN_META_FALLBACK_DEEPLINK_WITH_WEB_FALLBACK_OPTION,
    label: ADS_CAMPAIGN_META_FALLBACK_DEEPLINK_WITH_WEB_FALLBACK,
  },
  {
    value: ADS_CAMPAIGN_META_FALLBACK_DEEPLINK_WITH_APPSTORE_FALLBACK_OPTION,
    label: ADS_CAMPAIGN_META_FALLBACK_DEEPLINK_WITH_APPSTORE_FALLBACK,
  },
  {
    value: ADS_CAMPAIGN_META_FALLBACK_WEB_ONLY_OPTION,
    label: ADS_CAMPAIGN_META_FALLBACK_WEB_ONLY,
  },
  {
    value: ADS_CAMPAIGN_META_FALLBACK_CATALOG_OPTION,
    label: ADS_CAMPAIGN_META_FALLBACK_CATALOG,
  },
];

export const optionsDestinationFallbackConfiguration = [
  {
    value: ADS_CAMPAIGN_META_FALLBACK_WEB_ONLY_OPTION,
    label: ADS_CAMPAIGN_META_FALLBACK_WEB_ONLY_LABEL,
  },
  {
    value: ADS_CAMPAIGN_META_FALLBACK_DEEPLINK_WITH_WEB_FALLBACK_OPTION,
    label: ADS_CAMPAIGN_META_FALLBACK_DEEPLINK_WITH_WEB_FALLBACK_LABEL,
  },
  {
    value: ADS_CAMPAIGN_META_FALLBACK_DEEPLINK_WITH_APPSTORE_FALLBACK_OPTION,
    label: ADS_CAMPAIGN_META_FALLBACK_DEEPLINK_WITH_APPSTORE_FALLBACK_LABEL,
  },
];

// VIDEO TYPES OPTIONS
export const optionsVideoTypesForPhysicalProduct = [
  { value: "unboxing", label: VIDEO_TYPE_UNBOXING },
  { value: "productShowcase", label: VIDEO_TYPE_PRODUCT_SHOWCASE },
  { value: "ugc", label: VIDEO_TYPE_UGC },
  { value: "lifestyle", label: VIDEO_TYPE_LIFESTYLE },
  { value: "testimonialsReviews", label: VIDEO_TYPE_TESTIMONIALS_REVIEWS },
  { value: "corporate", label: VIDEO_TYPE_CORPORATE },
  { value: "surreal", label: VIDEO_TYPE_SURREAL },
  { value: "megaCreative", label: VIDEO_TYPE_MEGA_CREATIVE },
  { value: "other", label: VIDEO_TYPE_OTHER },
];

export const optionsAdsCampaignObjectivesLinkedin = [
  {
    value: ADS_CAMPAIGN_OBJECTIVE_AWARENESS_OPTION,
    label: ADS_CAMPAIGN_OBJECTIVE_AWARENESS,
    title: ADS_CAMPAIGN_OBJECTIVE_AWARENESS_TITLE_EXPLANATION,
    explanation: ADS_CAMPAIGN_OBJECTIVE_AWARENESS_DESCRIPTION_EXPLANATION,
  },
  {
    value: ADS_CAMPAIGN_OBJECTIVE_TRAFFIC_OPTION,
    label: ADS_CAMPAIGN_OBJECTIVE_TRAFFIC,
    title: ADS_CAMPAIGN_OBJECTIVE_TRAFFIC_TITLE_EXPLANATION,
    explanation: ADS_CAMPAIGN_OBJECTIVE_TRAFFIC_DESCRIPTION_EXPLANATION,
  },
  {
    value: ADS_CAMPAIGN_OBJECTIVE_ENGAGEMENT_OPTION,
    label: ADS_CAMPAIGN_OBJECTIVE_ENGAGEMENT,
    title: ADS_CAMPAIGN_OBJECTIVE_ENGAGEMENT_TITLE_EXPLANATION,
    explanation: ADS_CAMPAIGN_OBJECTIVE_ENGAGEMENT_DESCRIPTION_EXPLANATION,
  },
  {
    value: ADS_CAMPAIGN_OBJECTIVE_VIDEO_VIEWS_OPTION,
    label: ADS_CAMPAIGN_OBJECTIVE_VIDEO_VIEWS,
    title: ADS_CAMPAIGN_OBJECTIVE_VIDEO_VIEWS_TITLE_EXPLANATION,
    explanation: ADS_CAMPAIGN_OBJECTIVE_VIDEO_VIEWS_DESCRIPTION_EXPLANATION,
  },
  {
    value: ADS_CAMPAIGN_OBJECTIVE_LEADS_OPTION,
    label: ADS_CAMPAIGN_OBJECTIVE_LEADS_LINKEDIN,
    title: ADS_CAMPAIGN_OBJECTIVE_LEADS_TITLE_EXPLANATION,
    explanation: ADS_CAMPAIGN_OBJECTIVE_LEADS_DESCRIPTION_EXPLANATION,
  },
  {
    value: ADS_CAMPAIGN_OBJECTIVE_WEBSITE_CONVERSIONS_OPTION,
    label: ADS_CAMPAIGN_OBJECTIVE_WEBSITE_CONVERSIONS,
    title: ADS_CAMPAIGN_OBJECTIVE_WEBSITE_CONVERSIONS_TITLE_EXPLANATION,
    explanation:
      ADS_CAMPAIGN_OBJECTIVE_WEBSITE_CONVERSIONS_DESCRIPTION_EXPLANATION,
  },
];

export const optionsAdsCampaignAdFormatLinkedin = [
  {
    value: "STANDARD_UPDATE",
    label: ADS_CAMPAIGN_LINKEDIN_AD_FORMAT_IMAGE,
  },
  {
    value: "SINGLE_VIDEO",
    label: ADS_CAMPAIGN_LINKEDIN_AD_FORMAT_VIDEO,
  },
  {
    value: "CAROUSEL",
    label: ADS_CAMPAIGN_LINKEDIN_AD_FORMAT_CAROUSEL,
  },
];

export const optionsCallToActionLinkedin = [
  { value: "APPLY", label: ADS_CAMPAIGN_CALL_TO_ACTION_APPLY },
  { value: "DOWNLOAD", label: ADS_CAMPAIGN_CALL_TO_ACTION_DOWNLOAD },
  { value: "VIEW_QUOTE", label: ADS_CAMPAIGN_CALL_TO_ACTION_VIEW_QUOTE },
  { value: "LEARN_MORE", label: ADS_CAMPAIGN_CALL_TO_ACTION_LEARN_MORE },
  { value: "SIGN_UP", label: ADS_CAMPAIGN_CALL_TO_ACTION_SIGN_UP },
  { value: "SUBSCRIBE", label: ADS_CAMPAIGN_CALL_TO_ACTION_SUBSCRIBE },
  { value: "REGISTER", label: ADS_CAMPAIGN_CALL_TO_ACTION_REGISTER },
  { value: "JOIN", label: ADS_CAMPAIGN_CALL_TO_ACTION_JOIN },
  { value: "ATTEND", label: ADS_CAMPAIGN_CALL_TO_ACTION_ATTEND },
  { value: "REQUEST_DEMO", label: ADS_CAMPAIGN_CALL_TO_ACTION_REQUEST_DEMO },
  { value: "SEE_MORE", label: ADS_CAMPAIGN_CALL_TO_ACTION_SEE_MORE },
  { value: "SHOP_NOW", label: ADS_CAMPAIGN_CALL_TO_ACTION_SHOP_NOW },
];

export const optionsVideoTypesForServices = [
  { value: "testimonialsReviews", label: VIDEO_TYPE_TESTIMONIAL },
  { value: "ugc", label: VIDEO_TYPE_UGC },
  { value: "emotionalStorytelling", label: VIDEO_TYPE_EMOTIONAL_STORYTELLING },
  { value: "caseStudy", label: VIDEO_TYPE_CASE_STUDY },
  { value: "corporate", label: VIDEO_TYPE_CORPORATE },
  { value: "surreal", label: VIDEO_TYPE_SURREAL },
  { value: "megaCreative", label: VIDEO_TYPE_MEGA_CREATIVE },
  { value: "other", label: VIDEO_TYPE_OTHER },
];

export const ADMIN_PRIMARY_KPI_OPTIONS = [
  { value: ADMIN_KPI_PRIMARY_LEADS },
  { value: ADMIN_KPI_PRIMARY_SALES },
  { value: ADMIN_KPI_PRIMARY_MESSAGES },
  { value: ADMIN_KPI_PRIMARY_INTERACTIONS },
  { value: ADMIN_KPI_PRIMARY_TRAFFIC },
  { value: ADMIN_KPI_PRIMARY_CONVERSIONS },
  { value: ADMIN_KPI_PRIMARY_DOWNLOADS },
  { value: ADMIN_KPI_PRIMARY_REACH },
  { value: ADMIN_KPI_PRIMARY_STORE_VISITS },
];

export const optionsCustomReportTemplate = [
  { value: "general", label: MODAL_CUSTOM_REPORT_TEMPLATE_GENERAL },
  { value: "sales", label: MODAL_CUSTOM_REPORT_TEMPLATE_SALES },
  { value: "leads", label: MODAL_CUSTOM_REPORT_TEMPLATE_LEADS },
  { value: "custom", label: MODAL_CUSTOM_REPORT_TEMPLATE_CUSTOM },
];

export const optionsCustomReportFormat = [
  { value: "pptx", label: MODAL_CUSTOM_REPORT_FORMAT_PPTX },
  { value: "pdf", label: MODAL_CUSTOM_REPORT_FORMAT_PDF },
];

export const optionsCustomReportLanguage = [
  { value: "es", label: SPANISH },
  { value: "en", label: ENGLISH },
];
